MinimogTheme.pubSubEvents = {
  cartError: "cart-error",
  cartUpdate: "cart-update",
  openCartDrawer: "open-cart-drawer",
  openSearchPopup: "open-search-popup",
  closeSearchPopup: "close-search-popup",
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: "variant-change",
  quantityUpdate: 'quantity-update',
  quantityRules: 'quantity-rules',
  quantityBoundries: 'quantity-boundries'
};
const requestDefaultConfigs = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};

MinimogTheme.config = {
  mqlMobile: false,
  mqlTablet: false,
  mediaQueryMobile: "screen and (max-width: 767px)",
  mediaQueryTablet: "screen and (max-width: 1023px)",
};

MinimogTheme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
};
(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
  MinimogTheme.config.mqlMobile = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      MinimogTheme.config.mqlMobile = true;
      document.dispatchEvent(new CustomEvent("matchMobile"));
    } else {
      MinimogTheme.config.mqlMobile = false;
      document.dispatchEvent(new CustomEvent("unmatchMobile"));
    }
  };

  // Tablet
  const mqltl = window.matchMedia(MinimogTheme.config.mediaQueryTablet);
  MinimogTheme.config.mqlTablet = mqltl.matches;
  mqltl.onchange = (e) => {
    if (e.matches) {
      MinimogTheme.config.mqlTablet = true;
      document.dispatchEvent(new CustomEvent("matchTablet"));
    } else {
      MinimogTheme.config.mqlTablet = false;
      document.dispatchEvent(new CustomEvent("unmatchTablet"));
    }
  };

  // Page transition
  var fader = document.querySelector(".m-page-transition");
  function __fadeInPage() {
    if (!window.AnimationEvent || !fader) return;

    let ignore_beforeunload = false;

    const loadingDesignMode = fader.dataset.designMode === "true";

    document.querySelectorAll("a[href^=mailto], a[href^=tel]").forEach((link) => {
      link.addEventListener("click", () => {
        ignore_beforeunload = true;
      });
    });

    if (loadingDesignMode && Shopify.designMode) {
      fader.classList.add("m-page-transition--design-mode");
    } else {
      // Page transition
      window.addEventListener("beforeunload", () => {
        if (!ignore_beforeunload) fader.classList.add("fade-in");
      });
      window.addEventListener("DOMContentLoaded", () => {
        document.documentElement.classList.remove("m:overflow-hidden");
        document.body.classList.remove("m:overflow-hidden");
        setScrollbarWidth();

        // fader.classList.remove('fade-in')
        setTimeout(() => {
          fader.classList.add("fade-out");
        }, 300);

        document.dispatchEvent(new CustomEvent("page:loaded"));
      });
      window.addEventListener("pageshow", (event) => {
        // Removes unload class when returning to page via history
        if (event.persisted) {
          fader.classList.remove("fade-in");
          // fader.classList.add('fade-out');
        }
      });
    }
  }
  __fadeInPage();
})();

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    if (!oldNode || !newContent) return;
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
class CountdownTimer {
  constructor(container, startTime, endTime, options = {}) {
    this.times = ["day", "hour", "min", "sec"];
    this.selectors = {
      day: ".countdown-timer-day",
      hour: ".countdown-timer-hour",
      min: ".countdown-timer-minute",
      sec: ".countdown-timer-sec",
    };
    this.DAY_IN_MS = 24 * 60 * 60 * 1000;
    this.HOUR_IN_MS = 60 * 60 * 1000;
    this.MIN_IN_MS = 60 * 1000;

    this.container = container;
    this.startTime = startTime;
    this.savedStartTime = startTime;
    this.endTime = endTime;
    this.options = Object.assign(
      {},
      {
        addZeroPrefix: true,
        loop: false,
        callback: () => { },
      },
      options
    );

    this.intervalTime = 1000;
    this.timer = null;
    this.domNodes = queryDomNodes(this.selectors, container);

    this.start();
  }

  start() {
    this.timer = setInterval(() => {
      if (this.startTime > this.endTime) this.stop();
      else this.update();
    }, this.intervalTime);

    this.container.style.removeProperty("opacity");
  }

  update() {
    const timeData = this.format(this.endTime - this.startTime);
    this.times.forEach((time) => {
      if (this.domNodes[time]) {
        this.domNodes[time].textContent = this.addZeroPrefix(timeData[time]);
      }
    });
    this.startTime += this.intervalTime;
  }

  stop() {
    clearInterval(this.timer);
    if (this.options.loop) {
      this.startTime = this.savedStartTime;
      this.start();
    } else {
      this.timer = null;
      this.options.callback();
    }
  }

  clear() {
    clearInterval(this.timer);
    this.timer = null;
    this.startTime = this.savedStartTime;
    this.times.forEach((time) => {
      if (this.domNodes[time]) {
        this.domNodes[time].textContent = "00";
      }
    });
  }

  addZeroPrefix(num) {
    if (this.options.addZeroPrefix && num < 10) {
      return `0${num}`;
    }
    return num.toString();
  }

  format(ms) {
    return {
      day: Math.floor(ms / this.DAY_IN_MS),
      hour: Math.floor(ms / this.HOUR_IN_MS) % 24,
      min: Math.floor(ms / this.MIN_IN_MS) % 60,
      sec: Math.floor(ms / 1000) % 60,
    };
  }
}
window.MinimogTheme.CountdownTimer = CountdownTimer;

class Tabs {
  constructor(container, cb = () => { }) {
    this.selectors = {
      tabHeaders: [".m-tab-header"],
      tabContents: [".m-tab-content"],
    };
    this.activeClass = "active";
    this.currentActiveIndex = -1;
    this.currentTab = null;
    this.container = container;
    this.cb = cb;
    this.domNodes = queryDomNodes(this.selectors, container);
    this.customSelect = this.container.querySelector("m-select-component");

    this.init();
    this.setActiveTab(0);
  }

  init() {
    addEventDelegate({
      context: this.container,
      selector: this.selectors.tabHeaders[0],
      handler: (e, tabHeader) => {
        e.preventDefault();
        let index;
        if (tabHeader) {
          index = Number(tabHeader.dataset.index);
        }
        this.setActiveTab(index);
        this.cb(tabHeader);
      },
    });
  }

  setActiveTab(tabIndex) {
    const { tabHeaders, tabContents } = this.domNodes;

    if (tabContents.length && tabIndex !== -1 && this.currentActiveIndex !== tabIndex) {
      let currHeader, newHeader, newTab;

      currHeader = tabHeaders && tabHeaders[this.currentActiveIndex];
      newHeader = tabHeaders && tabHeaders[tabIndex];

      if (this.customSelect && newHeader) {
        const tabHeaderStyle = this.customSelect.dataset.tabHeader;
        tabHeaderStyle === "select" && this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML);
        if (MinimogTheme.config.mqlMobile) {
          this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML);
        }
        document.addEventListener("matchMobile", () =>
          this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML)
        );
      }

      newTab = tabContents && tabContents[tabIndex];

      currHeader && currHeader.classList.remove(this.activeClass);
      this.currentTab && this.currentTab.classList.remove(this.activeClass);

      newHeader && newHeader.classList.add(this.activeClass);
      newTab && newTab.classList.add(this.activeClass);
      setTimeout(() => (newTab.style.opacity = 1));

      this.currentActiveIndex = tabIndex;
      this.currentTab = newTab;
    }
  }
}
window.MinimogTheme.Tabs = Tabs;

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

function setScrollbarWidth() {
  document.documentElement.style.setProperty(
    "--m-scrollbar-width",
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );
}

setScrollbarWidth();

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = "minimog:check";
  let storage;
  if (type === "session") {
    storage = window.sessionStorage;
  }
  if (type === "local") {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getRequestDefaultConfigs() {
  return JSON.parse(JSON.stringify(requestDefaultConfigs));
}

function fetchJSON(url, config = getRequestDefaultConfigs()) {
  return fetch(url, config).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

const cache = new Map();
function fetchCache(url, config = getRequestDefaultConfigs()) {
  return new Promise((resolve, reject) => {
    let cached = cache.get(url);
    if (cached) return resolve(cached);
    fetch(url, config)
      .then((res) => {
        cached = res.text();
        cache.set(url, cached);
        resolve(cached);
      })
      .catch(reject);
  });
}

const sectionCache = new Map();
function fetchSection(sectionId, options = {}) {
  const { url: _url, fromCache = false, params = {} } = options;

  return new Promise((resolve, reject) => {
    const url = new URL(_url || window.location.href);
    url.searchParams.set("section_id", sectionId);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));

    if (fromCache) {
      const cached = sectionCache.get(url);
      if (cached) return resolve(cached);
    }

    fetch(url, getRequestDefaultConfigs())
      .then((res) => {
        if (res.ok) return res.text();
        reject(`Failed to load section: ${sectionId}`);
      })
      .then((html) => {
        const div = generateDomFromString(html);
        sectionCache.set(url, div);
        resolve(div);
        // const div = <div />
        // div.innerHTML = html
        // sectionCache.set(url, div)
        // resolve(div)
      })
      .catch(reject);
  });
}

const cache2 = new Map();
function fetchJsonCache(url, config = requestDefaultConfigs) {
  return new Promise((resolve, reject) => {
    if (cache2.get(url)) {
      return resolve(cache2.get(url));
    }
    fetch(url, config)
      .then((res) => {
        if (res.ok) {
          const json = res.json();
          resolve(json);
          cache2.set(url, json);
          return json;
        } else {
          reject(res);
        }
      })
      .catch(reject);
  });
}

function formatMoney(cents, format) {
  const moneyFormat = "${{amount}}";
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function validateForm(form) {
  const missingFields = [];
  if (!form) return missingFields;
  const fieldSelectors = '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
  const requiredFields = form.querySelectorAll(fieldSelectors);
  requiredFields.forEach((field) => {
    field.classList.remove("form-control--warning");
    if (field.type === "radio") {
      const buttons = form.querySelectorAll(`input[name="${field.name}"]`);
      const selected = Array.from(buttons).some((btn) => btn.checked);
      if (!selected) {
        missingFields.push(field);
        field.classList.add("form-control--warning");
      }
    } else if (!field.value) {
      missingFields.push(field);
      field.classList.add("form-control--warning");
    }
  });
  return missingFields;
}

function generateDomFromString(value, tagName = "div") {
  const d = document.createElement(tagName);
  d.innerHTML = value;
  return d;
}

function generateDomeFromStringNew(value, selector = "div") {
  const dom = new DOMParser().parseFromString(value, "text/html");
  const newDom = dom.querySelector(selector);
  return newDom;
}

function fetchCountDown(collectionID) {
  const appURL = MinimogSettings.foxKitBaseUrl ? `https://${MinimogSettings.foxKitBaseUrl}` : "";

  return new Promise((resolve, reject) => {
    let requestUrl = `${appURL}/api/public/countdown?shop=${window.Shopify.shop}&collectionIds=${collectionID}`;

    fetch(requestUrl)
      .then((response) => response.json())
      .then(resolve)
      .catch(reject);
  });
}

function loadAssetsNew(files = [], id, callback = () => { }, options = {}) {
  const unique = id ? id : Math.random().toString(36).slice(2);
  if (!window.MinimogLibs.loadjs.isDefined(id)) window.MinimogLibs.loadjs(files, unique);
  window.MinimogLibs.loadjs.ready(unique, callback);
}

function pauseAllMedia(container = document) {
  container.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  container.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  container.querySelectorAll("video").forEach((video) => video.pause());
  container.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function loadJS(src, target = document.body, async = false, defer = true) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currScript = doc.querySelector(`script[src="${src}"]`);
    if (currScript) {
      if (currScript.dataset.loaded) return resolve(true);
      currScript.addEventListener("load", () => {
        currScript.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const script = doc.createElement("script");
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.addEventListener("load", () => {
      script.dataset.loaded = true;
      resolve(true);
    });
    script.onerror = reject;
    target.appendChild(script);
  });
}

function loadCSS(href, target = document.head) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currLink = doc.querySelector(`link[href="${href}"]`);
    if (currLink) {
      if (currLink.dataset.loaded) return resolve(true);
      currLink.addEventListener("load", () => {
        currLink.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const link = doc.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.addEventListener("load", () => {
      link.dataset.loaded = true;
      resolve(true);
    });
    link.onerror = reject;
    target.appendChild(link);
  });
}

function addEventDelegate({ context = document.documentElement, event = "click", selector, handler, capture = false }) {
  const listener = function (e) {
    // loop parent nodes from the target to the delegation node
    for (let target = e.target; target && target !== this; target = target.parentNode) {
      if (target.matches(selector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };
  context.addEventListener(event, listener, capture);
  return () => {
    context.removeEventListener(event, listener, capture);
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === "object") {
    throw new Error(options + "is not a valid array of options.");
  }
}

function _validateProductStructure(product) {
  if (typeof product !== "object") {
    throw new TypeError(product + " is not an object.");
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + " is empty.");
  }
}

function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);
  var result = product.variants.filter(function (variant) {
    return options.every(function (option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === "master") {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|webp|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + "_" + size + suffix);
  } else {
    return null;
  }
}

function removeProtocol(path) {
  return path.replace(/http(s)?:/, "");
}

function updateParam(key, value) {
  var { location } = window;
  var baseUrl = [location.protocol, "//", location.host, location.pathname].join("");

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  if (urlParams.has(key)) {
    if (value !== "" && value !== "undefined") {
      urlParams.set(key, value);
    }
    if (value === "" || value === "undefined") {
      urlParams.delete(key);
    }
  } else {
    if (value) urlParams.append(key, value);
  }

  window.history.replaceState({}, "", baseUrl + "?" + urlParams.toString());
  return false;
}

function createSearchLink(query) {
  const searchParams = new URLSearchParams({
    type: "product",
    ["options[unavailable_products]"]: "last",
    ["options[prefix]"]: "last",
    q: query,
  });

  const searchURL = window.MinimogSettings.routes.search_url;
  return `${searchURL}?${searchParams.toString()}`;
}

function refreshProductReview() {
  if (typeof SMARTIFYAPPS !== "undefined" && SMARTIFYAPPS.rv.installed) {
    SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews();
  }
  if (typeof Yotpo !== "undefined" && typeof Yotpo.API === "function") {
    const yotpoApi = new Yotpo.API(yotpo);
    yotpoApi?.refreshWidgets();
  }
}

// SetPopularSearchLink
(function () {
  const popularSearchItems = document.querySelectorAll("[data-ps-item]");
  if (popularSearchItems) {
    popularSearchItems.forEach((itm) => (itm.href = createSearchLink(itm.dataset.psQuery)));
  }
})();

function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    if (context) {
      acc[name] = context[queryMethod](sl);
    }
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}

function saleProgress(settings, productId, soldNumber) {
  const { total_quantity, sold_to, sold_from } = settings;
  let soldNumb;
  // const hour = new Date().getHours()
  if (soldNumber) {
    soldNumb = parseInt(soldNumber);
  } else {
    const hour = 4;
    const range = sold_to - sold_from;
    const timeRatio = hour / 24;
    const randomRatioById = (Number(productId.split("").pop()) + 1) / 10;
    let combinedRatio = timeRatio + randomRatioById;
    if (combinedRatio > 1) combinedRatio -= 1;

    const delta = Math.ceil(combinedRatio * range);
    soldNumb = sold_from + delta;
  }

  const availableNumb = total_quantity - soldNumb;
  const progress = (soldNumb * 100) / total_quantity;

  return `
    <div class="m-product-sale-progress">
      <div class="m-product-sale-progress__bar" data-flash-sale>
        <span data-sale-progress style="width: ${progress}%;" />
      </div>
      <div class="m-product-sale-progress__text">
        <div>
          <span>${MinimogStrings.sold}: </span>
          <strong data-sale-number>${soldNumb || 0}</strong>
        </div>
        <div>
          <span>${MinimogStrings.available}: </span>
          <strong data-available-number>${availableNumb || 0}</strong>
        </div>
      </div>
    </div>
  `;
}

function spinner(className = "") {
  return `<svg class="animate-spin m:hidden m-svg-icon--medium ${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>`;
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function formatUrl(pageType, handle, query) {
  let url;
  const { routes } = MinimogSettings;
  const root = routes.root.endsWith("/") ? "" : routes.root;
  url = `${root}/${pageType}/${handle}`;
  if (query) url += `?${query}`;
  return url;
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id*="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      this.deferredElement = deferredElement;

      if (focus) deferredElement.focus();
      this.playVideo(deferredElement);
    }
  }

  playVideo(videoElm) {
    if (this.autoPlay) return;

    if (videoElm.classList.contains("js-youtube")) {
      const symbol = videoElm.src.indexOf("?") > -1 ? "&" : "?";
      videoElm.src += symbol + "autoplay=1&mute=1";
    } else if (videoElm.classList.contains("js-vimeo")) {
      const symbol = videoElm.src.indexOf("?") > -1 ? "&" : "?";
      videoElm.src += symbol + "autoplay=1&muted=1";
    } else {
      videoElm && videoElm.setAttribute("autoplay", "autoplay");
      videoElm && videoElm.play();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class ResponsiveImage extends HTMLElement {
  get intersecting() {
    return this.hasAttribute("intersecting");
  }
  constructor() {
    super();
    this.img = this.querySelector("img");
    this.src = this.img.src;
    this.observerCallback = this.observerCallback.bind(this);
    if (this.img) {
      this.loadImage = this.loadImage.bind(this);
      this.img.onload = this.onLoad.bind(this);
    }
    if (this.img.complete) {
      this.onLoad();
    }
  }
  connectedCallback() {
    // this.img.src = "";
    if ("IntersectionObserver" in window) {
      this.initIntersectionObserver();
    } else {
      this.loadImage();
    }
  }
  disconnectedCallback() {
    this.disconnectObserver();
  }
  loadImage() {
    this.setAttribute("intersecting", "true");
    if (this.img) {
      this.img.src = this.src;
      this.img.width = this.clientWidth;
      this.img.height = this.clientHeight;
      this.img.sizes = this.clientWidth + "px";
    }
    window.MinimogEvents.emit(`m:image-loaded`, this.imageLoaded, this);
  }
  onLoad() {
    this.removeAttribute("");
    this.classList.add("m-image-loaded");
  }
  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadImage();
  }
  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = "10px";
    this.observer = new IntersectionObserver(this.observerCallback, { rootMargin });
    this.observer.observe(this);
  }
  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}
customElements.define("responsive-image", ResponsiveImage);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      gridContainer: ".m-product-list",
      swiperWrapper: ".swiper-wrapper",
      slideControls: ".m-slider-controls",
    };

    this.enableSlider = this.dataset.enableSlider === "true";
    this.useScrollMobile = this.dataset.useScrollMobile === "true";
    this.itemsPerPage = this.dataset.itemsPerPage;
    this.paginationType = this.dataset.paginationType;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = generateDomFromString(text);
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.totalProducts = recommendations.querySelectorAll(".m-product-card").length;

            this.initByScreenSize();
            document.addEventListener("matchMobile", () => {
              this.initByScreenSize();
            });
            document.addEventListener("unmatchMobile", () => {
              this.initByScreenSize();
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
  }

  initByScreenSize() {
    const { gridContainer, slideControls } = queryDomNodes(this.selectors, this);

    if (MinimogTheme.config.mqlMobile) {
      this.initSlider();
      if (!this.useScrollMobile) return;
      gridContainer && gridContainer.classList.remove("swiper-container");
      slideControls && slideControls.classList.add("m:hidden");
      if (this.swiper) this.swiper.destroy(false, true);
      gridContainer && gridContainer.parentNode.classList.add("m-mixed-layout--mobile-scroll");
    } else {
      gridContainer && gridContainer.classList.add("swiper-container");
      gridContainer && gridContainer.parentNode.classList.remove("m-mixed-layout--mobile-scroll");
      slideControls && slideControls.classList.remove("m:hidden");
      this.initSlider();
    }
  }

  initSlider() {
    let __this = this;
    const { gridContainer, slideControls } = queryDomNodes(this.selectors, this);
    if (this.enableSlider && this.totalProducts > this.itemsPerPage) {
      this.slider = new MinimogLibs.Swiper(gridContainer, {
        slidesPerView: this.itemsPerPage >= 2 ? 2 : 1,
        loop: true,
        autoplay: false,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
          type: this.paginationType,
        },
        threshold: 2,
        breakpoints: {
          1280: {
            slidesPerView: this.itemsPerPage,
          },
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive);
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
              const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");
              if (firstItem && slideControls) {
                const itemHeight = firstItem.clientHeight;
                slideControls.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton.classList.remove("m:hidden");
                nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
        },
      });

      if (this.slider) {
        slideControls && slideControls.classList.remove("m:hidden");
        const prevBtn = this.querySelector(".m-slider-controls__button-prev");
        const nextBtn = this.querySelector(".m-slider-controls__button-next");
        prevBtn && prevBtn.addEventListener("click", () => this.slider.slidePrev());
        nextBtn && nextBtn.addEventListener("click", () => this.slider.slideNext());
      }

      this.swiper = gridContainer?.swiper;
    } else {
      const innerContainer = gridContainer.querySelector(".m-mixed-layout__inner");
      innerContainer && innerContainer.classList.remove("swiper-wrapper");
      slideControls && slideControls.classList.add("m:hidden");
      gridContainer && gridContainer.classList.remove("swiper-container");
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);

if (!customElements.get("video-component")) {
  customElements.define(
    "video-component",
    class VideoComponent extends HTMLElement {
      constructor() {
        super();
        MinimogTheme.initWhenVisible({
          element: this,
          callback: this.init.bind(this),
          threshold: 0,
        });
      }

      init() {
        this.autoPlay = this.dataset.autoPlay === "true";
        this.muted = this.dataset.muted === "true";
        const poster = this.querySelector('[id^="Video-Deferred-Poster-"]');
        if (this.autoPlay) {
          this.loadContent();
        } else {
          poster && poster.addEventListener("click", this.loadContent.bind(this));
        }
      }

      loadContent() {
        if (!this.getAttribute("loaded")) {
          const content = document.createElement("div");
          content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

          this.setAttribute("loaded", true);
          const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
          this.deferredElement = deferredElement;

          if (this.autoPlay) return;

          if (this.deferredElement.classList.contains("js-youtube")) {
            const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            this.deferredElement.src += symbol + `autoplay=1${this.muted ? "&mute=1" : ""}`;
          } else if (this.deferredElement.classList.contains("js-vimeo")) {
            const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            this.deferredElement.src += symbol + `autoplay=1${this.muted ? "&mute=1" : ""}`;
          } else {
            this.deferredElement.play();
          }
        }
      }
    }
  );
}

if (!customElements.get("collapsible-tab")) {
  class CollapsibleTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.parentEl = this.closest("[data-section-id]");
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      const destroy = this.dataset.destroy === "true";
      if (destroy) return;

      this.setDefaultData();
      this.attachEvents();

      if (this.getAttribute("open") === "true") {
        this.selected = true;
        this.classList.add(this.expandedClass);
        this.setExpandedAria();
        this.fire("tabOpened");
        window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this);
      } else {
        this.content.style.height = this.collapsedHeight;
        this.classList.add(this.collapsedClass);
        this.setCollapsedAria();
      }
      this.content.removeAttribute("hidden");
    }

    transitionendEventName() {
      let i,
        el = document.createElement("div"),
        transitions = {
          transition: "transitionend",
          OTransition: "otransitionend",
          MozTransition: "transitionend",
          WebkitTransition: "webkitTransitionEnd",
        };

      for (i in transitions) {
        if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
          return transitions[i];
        }
      }
    }

    expand() {
      const resetHeight = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (!this.isOpen) return;

        requestAnimationFrame(() => {
          this.content.style.transition = "0";
          this.content.style.height = "auto";

          requestAnimationFrame(() => {
            this.content.style.height = null;
            this.content.style.transition = null;

            this.setExpandedAria();
            this.classList.add(this.expandedClass);
            this.trySetTabIndex(this.content, 0);

            this.fire("tabOpened");
            window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this);
          });
        });
      };

      const bindEvent = resetHeight.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = true;
      this.classList.remove(this.collapsedClass);
      this.content.style.height = this.content.scrollHeight + "px";
    }

    collapse() {
      const endTransition = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (this.isOpen) return;

        this.fire("elementClosed");
        window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_CLOSED`, this);
        this.setCollapsedAria();
        this.classList.add(this.collapsedClass);
        this.trySetTabIndex(this.content, -1);
      };

      const bindEvent = endTransition.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = false;
      this.classList.remove(this.expandedClass);

      requestAnimationFrame(() => {
        this.content.style.transition = "0";
        this.content.style.height = this.content.scrollHeight + "px";

        requestAnimationFrame(() => {
          this.content.style.transition = null;
          this.content.style.height = this.collapsedHeight;
        });
      });
    }

    open() {
      this.selected = true;
      this.fire("elementSelected");
      window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_SELECTED`, this);
      this.expand();
      this.setAttribute("open", true);
    }

    close() {
      this.selected = false;
      this.fire("elementUnselected");
      window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_UNSELECTED`, this);
      this.collapse();
      this.removeAttribute("open");
    }

    toggle(event) {
      if (event) {
        event.preventDefault();
      }
      if (this.selected) {
        this.close();
      } else {
        this.open();

        if (this.oneAtATime) {
          const allItems = this.parentEl.querySelectorAll("collapsible-tab");
          const parent = this.closest("[data-first-level]");
          if (allItems.length) {
            allItems.forEach((item) => {
              if (item !== this && item.selected && parent !== item) {
                item.close();
              }
            });
          }
        }
      }
    }

    trySetTabIndex(el, index) {
      const tappableElements = el.querySelectorAll(this.defaultElements);
      if (tappableElements) {
        tappableElements.forEach((e) => {
          e.setAttribute("tabindex", index);
        });
      }
    }

    setExpandedAria() {
      this.trigger.setAttribute("aria-expanded", "true");
      this.content.setAttribute("aria-hidden", "false");
    }

    setCollapsedAria(el) {
      this.trigger.setAttribute("aria-expanded", "false");
      this.content.setAttribute("aria-hidden", "true");
    }

    attachEvents() {
      this.trigger.addEventListener("click", (event) => this.toggle(event));
    }

    setDefaultData() {
      this.events = {
        elementSelected: [],
        tabOpened: [],
        elementUnselected: [],
        elementClosed: [],
      };
      this.transitionendevent = this.transitionendEventName();
      this.expandedClass = "is-expanded";
      this.collapsedClass = "is-collapsed";
      this.trigger = this.querySelector("[data-trigger]");
      this.content = this.querySelector("[data-content]");
      this.collapsedHeight = "0px";
      this.defaultElements = ["a", "button", "input:not(.focus-none)", "[data-trigger]"];
      this.oneAtATime = true;
      if (this.dataset.oneOpen) {
        this.oneAtATime = this.dataset.oneOpen === "true";
      }
    }

    fire(eventName) {
      let callbacks = this.events[eventName];
      if (callbacks) {
        for (let i = 0; i < callbacks.length; i++) {
          callbacks[i](this);
        }
      }
    }

    on(eventName, cb) {
      if (!this.events[eventName]) return;
      this.events[eventName].push(cb);
    }

    destroy() {
      this.trigger.removeEventListener("click", (event) => this.toggle(event));
      this.content.removeAttribute("aria-hidden");
      this.content.style.height = "auto";
      this.classList.remove(this.expandedClass, this.collapsedClass);
      this.removeAttribute("open");
    }
  }

  customElements.define("collapsible-tab", CollapsibleTab);
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".m-product-form-message",
          customFields: ["[data-product-custom-field]"],
          dynamicCheckout: ".m-product-dynamic-checkout",
        };
      }
      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        this.form = this.domNodes.form;
        this.productInfo = this.closest(".m-main-product--info");
        this.submitButton = this.domNodes.submitButton;
        this.domNodes.inputId.disabled = false;
        this.cart = document.querySelector("m-cart-drawer");
        this.cartPage = document.querySelector("m-cart");
        this.customFields = document.querySelectorAll(this.selectors.customFields);
        if (this.domNodes.dynamicCheckout) this.enable_dynamic_checkout = true;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        if (this.domNodes.dynamicCheckout && this.customFields) {
          this.domNodes.dynamicCheckout.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.form.closest(".m-main-product--info"));
              if (missing && missing.length > 0) {
                e.stopPropagation();
                window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper,
                  method: "appendChild",
                  type: "warning",
                  message: window.MinimogStrings.requiredField,
                  delay: 100,
                });
                console.warn("Missing field(s): ", missing);
              }
            },
            true
          );
        }
      }
      toggleSpinner(show) {
        const method = show ? "add" : "remove";
        this.classList[method]("m-spinner-loading");
      }
      getFormData() {
        const formData = new FormData(this.form);
        if (this.closest('sticky-atc')) {
          const form = document.querySelector('.m-main-product--info .m-product-form--main form');
          const extraFormData = new FormData(form);

          for (const [key, value] of extraFormData.entries()) {
            if (!formData.has(key)) {
              formData.set(key, value);
            }
          }
        }

        return formData;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.toggleSpinner(true);
        const missing = validateForm(this.form.closest(".m-main-product--info"));

        if (missing && missing.length > 0) {
          console.warn("Missing field(s): ", missing);
          this.toggleSpinner(false);
          return window.MinimogTheme.Notification.show({
            target: this.domNodes.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.MinimogStrings.requiredField,
          });
        }

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = this.getFormData();
        formData.append("sections", sectionsToBundle);
        formData.append("sections_url", window.location.pathname);

        config.body = formData;

        const { MinimogSettings, MinimogStrings } = window;
        fetch(`${MinimogSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // Handle Error
            if (response.status) {
              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.error || response.description,
                message: response.message,
              });
              document.dispatchEvent(
                new CustomEvent("product-ajax:error", {
                  detail: {
                    errorMessage: response.error || response.description,
                  },
                })
              );
              this.error = true;
              const variantId = formData.get("id");
              if (variantId === "" || variantId === null) {
                this.handleErrorMessageVariantPicker();
                return window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "error",
                  message: MinimogStrings.selectVariant,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
              } else {
                return window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "error",
                  message: response.message,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
              }
            }

            if (MinimogSettings.use_ajax_atc) {
              // Handle Ajax ATC
              if (this.cart && MinimogSettings.enable_cart_drawer) {
                MinimogTheme.Notification.show({
                  target: this.cart.querySelector("m-cart-items"),
                  method: "prepend",
                  type: "success",
                  message: MinimogStrings.itemAdded,
                  delay: 400,
                });
                // Open cart drawer
                this.cart.open();
              } else {
                window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "success",
                  message: MinimogStrings.itemAdded,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
              }

              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response, productVariantId: formData.get('id') });

              // dispatch product added event
              document.dispatchEvent(
                new CustomEvent("product-ajax:added", {
                  detail: {
                    product: response,
                  },
                })
              );

              this.error = false;

            } else {
              window.location = MinimogSettings.routes.cart;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.toggleSpinner(false);
          });
      }
      handleErrorMessageVariantPicker() {
        const variantPicker = this.productInfo && this.productInfo.querySelector("variant-picker");
        const options = variantPicker && variantPicker.querySelectorAll("[data-selected-value]");

        options &&
          options.forEach((option) => {
            const value = option.dataset.selectedValue;
            if (value === "") {
              option.classList.add("m-product-option--unselect");
              setTimeout(() => {
                option.classList.remove("m-product-option--unselect");
              }, 3000);
            }
          });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get("m-video-component")) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();
      this.background = this.dataset.initMode !== "template";
      if (this.background) {
        MinimogTheme.initWhenVisible({
          element: this,
          callback: this.init.bind(this),
          threshold: 0,
        });
      } else {
        this.init();
      }
    }

    init() {
      this.parentSelector = this.dataset.parent || ".m-hero__bg";
      this.parent = this.closest(this.parentSelector);

      switch (this.dataset.type) {
        case "youtube":
          this.initYoutubeVideo();
          break;

        case "vimeo":
          this.initVimeoVideo();
          break;

        case "mp4":
          this.initMp4Video();
          break;
      }
    }

    initYoutubeVideo() {
      this.setAsLoading();
      this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
    }

    initVimeoVideo() {
      this.setAsLoading();
      this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
    }

    initMp4Video() {
      const player = this.querySelector("video");

      if (player) {
        const promise = player.play();

        // Edge does not return a promise (video still plays)
        if (typeof promise !== "undefined") {
          promise
            .then(function () {
              // playback normal
            })
            .catch(function () {
              player.setAttribute("controls", "");
            });
        }
      }
    }

    loadScript(videoType) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = videoType === "youtube" ? "//www.youtube.com/iframe_api" : "//player.vimeo.com/api/player.js";
      });
    }

    setAsLoading() {
      this.parent.setAttribute("loading", true);
    }

    setAsLoaded() {
      this.parent.removeAttribute("loading");
      this.parent.setAttribute("loaded", true);
    }

    setupYoutubePlayer() {
      const videoId = this.dataset.videoId;
      const playerInterval = setInterval(() => {
        if (window.YT) {
          window.YT.ready(() => {
            const element = document.createElement("div");
            this.appendChild(element);

            this.player = new YT.Player(element, {
              videoId: videoId,
              playerVars: {
                showinfo: 0,
                controls: false,
                fs: 0,
                rel: 0,
                height: "100%",
                width: "100%",
                iv_load_policy: 3,
                html5: 1,
                loop: 1,
                playsinline: 1,
                modestbranding: 1,
                disablekb: 1,
              },
              events: {
                onReady: this.onYoutubeReady.bind(this),
                onStateChange: this.onYoutubeStateChange.bind(this),
              },
            });
            clearInterval(playerInterval);
          });
        }
      }, 50);
    }

    onYoutubeReady() {
      this.iframe = this.querySelector("iframe"); // iframe once YT loads
      this.iframe.setAttribute("tabindex", "-1");
      if (typeof this.player.mute === "function") this.player.mute();
      if (typeof this.player.playVideo === "function") this.player.playVideo();

      this.setAsLoaded();

      // pause when out of view
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.youtubePlay();
              } else {
                this.youtubePause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      }
    }

    onYoutubeStateChange(event) {
      switch (event.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (this.attemptedToPlay) {
            this.setAsLoaded();
            // this.closest('.banner').classList.add('video-interactable');
          }
          break;
        case 0: // ended, loop it
          this.youtubePlay();
          break;
        case 1: // playing
          this.setAsLoaded();
          break;
        case 3: // buffering
          this.attemptedToPlay = true;
          break;
      }
    }

    youtubePlay() {
      if (this.player && typeof this.player.playVideo === "function") {
        this.player.playVideo();
      }
    }

    youtubePause() {
      if (this.player && typeof this.player.pauseVideo === "function") {
        this.player.pauseVideo();
      }
    }

    setupVimeoPlayer() {
      const videoId = this.dataset.videoId;

      const playerInterval = setInterval(() => {
        if (window.Vimeo) {
          this.player = new Vimeo.Player(this, {
            id: videoId,
            autoplay: true,
            autopause: false,
            background: false,
            controls: false,
            loop: true,
            height: "100%",
            width: "100%",
          });
          this.player.ready().then(this.onVimeoReady.bind(this));
          clearInterval(playerInterval);
        }
      }, 50);
    }

    onVimeoReady() {
      this.iframe = this.querySelector("iframe");
      this.iframe.setAttribute("tabindex", "-1");

      this.player.setMuted(true);

      this.setAsLoaded();

      // pause when out of view
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.vimeoPlay();
            } else {
              this.vimeoPause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this.iframe);
    }

    vimeoPlay() {
      if (this.player && typeof this.player.play === "function") {
        this.player.play();
      }
    }

    vimeoPause() {
      if (this.player && typeof this.player.pause === "function") {
        this.player.pause();
      }
    }
  }
  customElements.define("m-video-component", VideoComponent);
}

if (!customElements.get("m-search-popup")) {
  class MSearchPopup extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        container: "[data-search-container]",
        form: "form",
        input: "[data-search-input]",
        submit: 'button[type="submit"]',
        loading: "[data-spinner]",
        close: "[data-close-search]",
      };

      const searchPopup = document.querySelector("[data-search-popup]");
      if (!searchPopup) return;

      this.domNodes = queryDomNodes(this.selectors, searchPopup);
      this.domNodes.searchPopup = searchPopup;
      document.body.appendChild(searchPopup);
      addEventDelegate({
        selector: "[data-open-search-popup]",
        handler: () => this.openSearchPopup(),
      });

      const { input, submit, close, form } = this.domNodes;
      if (input) {
        input.addEventListener("keydown", (e) => {
          // ESC
          if (e.keyCode === 27) {
            this.closeSearchPopup();
          }
        });
      }
      submit.addEventListener("click", (e) => {
        e.preventDefault();
        if (input.value) {
          form.submit();
        }
      });
      close.addEventListener("click", (e) => {
        this.closeSearchPopup();
        MinimogEvents.emit(MinimogTheme.pubSubEvents.closeSearchPopup);
      });
      searchPopup.addEventListener("click", (e) => {
        if (e.target === searchPopup) {
          this.closeSearchPopup();
        }
      });

      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
        if (this.hasAttribute("open")) this.closeSearchPopup();
      });
    }

    openSearchPopup() {
      const { searchPopup, input, container } = this.domNodes;
      searchPopup.style.removeProperty("visibility");
      searchPopup.style.setProperty("opacity", "1");
      container.classList.add("m-show-search");
      this.setAttribute("open", true);
      setTimeout(() => {
        container.style.removeProperty("--m-durations");
        input.focus();
      }, 350);
      document.documentElement.classList.add("prevent-scroll");
      MinimogEvents.emit(MinimogTheme.pubSubEvents.openSearchPopup, this);
    }

    closeSearchPopup() {
      const { searchPopup, container } = this.domNodes;
      container.classList.remove("m-show-search");
      searchPopup.style.setProperty("opacity", "0");
      setTimeout(() => {
        searchPopup.style.setProperty("visibility", "hidden");
        container.style.setProperty("--m-durations", ".3s");
        document.documentElement.classList.remove("prevent-scroll");
        this.removeAttribute("open");
      }, 350);
    }
  }

  customElements.define("m-search-popup", MSearchPopup);
}

if (!customElements.get("m-select-component")) {
  class MSelectComponent extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        elSelectNative: ".js-selectNative",
        elSelectCustom: ".js-selectCustom",
        elSelectCustomBox: ".m-select-custom--trigger",
        elSelectCustomOpts: ".m-select-custom--options",
        elSelectCustomTriggerText: ".m-select-custom--trigger-text",
        customOptionList: [".m-select-custom--option"],
      };

      this.domNodes = queryDomNodes(this.selectors, this);
      this.optionChecked = "";

      window.addEventListener("DOMContentLoaded", () => {
        this.classList.remove("m:hidden");
      });
      this.setDefaultValue();
      this.initSelect();
    }

    setDefaultValue() {
      const { elSelectNative } = this.domNodes;
      const value = elSelectNative.options[elSelectNative.selectedIndex].value;
      const text = elSelectNative.options[elSelectNative.selectedIndex].text;
      this.updateCustomSelectChecked(value, text);
    }

    initSelect() {
      this.classList.remove("m:hidden");
      const { elSelectNative, elSelectCustom, elSelectCustomBox } = this.domNodes;

      elSelectCustomBox.addEventListener("click", () => {
        const isClose = !elSelectCustom.classList.contains("isActive");
        if (isClose) {
          this.openSelect();
        } else {
          this.closeSelect();
        }
      });

      this.domNodes.customOptionList.forEach((option) => {
        option.addEventListener("click", (e) => {
          const value = e.target.getAttribute("data-value");
          elSelectNative.value = value;
          this.closeSelect();
          this.updateCustomSelectChecked(value, e.target.textContent);
          elSelectNative.dispatchEvent(new Event("change"));
          elSelectNative.dispatchEvent(new Event("click"));
        });
      });
    }

    openSelect() {
      const allCustomSelect = document.querySelectorAll("m-select-component");
      document.addEventListener("click", (e) => this.handleClickOutside(e));
      if (allCustomSelect.length > 0) {
        allCustomSelect.forEach((select) => {
          select.closeSelect();
        });
      }
      this.domNodes.elSelectCustom.classList.add("isActive");
    }

    closeSelect() {
      this.domNodes.elSelectCustom.classList.remove("isActive");
    }

    updateCustomSelectChecked(value, text) {
      const { elSelectCustomOpts, elSelectCustomTriggerText } = this.domNodes;
      const prevValue = this.optionChecked;
      const elPrevOption = elSelectCustomOpts.querySelector(`[data-value="${prevValue}"`);

      const elOption = elSelectCustomOpts.querySelector(`[data-value="${value}"`);

      if (elPrevOption) {
        elPrevOption.classList.remove("isActive");
      }

      if (elOption) {
        elOption.classList.add("isActive");
      }

      elSelectCustomTriggerText.textContent = text;
      this.optionChecked = value;
    }

    handleClickOutside(e) {
      const { elSelectCustom } = this.domNodes;
      const didClickedOutside = !elSelectCustom.contains(e.target);
      if (didClickedOutside) {
        this.closeSelect();
      }
    }
  }

  customElements.define("m-select-component", MSelectComponent);
}

class MQuantityInput extends HTMLElement {
  quantityUpdateUnsubscriber = undefined;

  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  get productId() {
    return this.getAttribute("data-product-id");
  }

  get input() {
    return this.querySelector("input");
  }

  get value() {
    return this.input.value;
  }

  connectedCallback() {
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.input.addEventListener('focus', () => setTimeout(() => this.input.select()));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.quantityUpdate,
      this.validateQtyRules.bind(this)
    );

    // Sync 2 inputs inside product info and sticky ATC
    this.shouldSync = this.closest('.m-main-product--info') || this.closest('sticky-atc');
    if (this.shouldSync) {
      window.addEventListener("syncProductQuantity", (event) => {
        if (event.detail !== this.input.value) {
          this.input.value = event.detail;
          this.validateQtyRules();
        }
      });
    }
  }
  onInputChange() {
    if (this.shouldSync) {
      window.dispatchEvent(new CustomEvent("syncProductQuantity", { detail: this.input.value }));
    }

    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.getAttribute('data-min')) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.getAttribute('data-min');
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.getAttribute('data-min') === previousValue && event.currentTarget.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    const buttonMinus = this.querySelector(".m-quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".m-quantity__button[name='plus']");

    if (this.input.min) {
      const min = parseInt(this.input.min);
      buttonMinus.classList.toggle("m:disabled", value <= min);
    } else {
      buttonMinus.classList.remove("m:disabled");
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      buttonPlus.classList.toggle("m:disabled", value >= max);
    } else {
      buttonPlus.classList.remove("m:disabled");
    }
  }

  updateQuantityRules(sectionId, productId, parsedHTML) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const selectors = [
      ".m-quantity__input",
      ".quantity__rules",
      ".m-product-option--label",
    ];
    const quantityFormUpdated = parsedHTML.getElementById(
      `QuantityForm-${sectionId}`
    );
    const quantityForm = this.closest(`#QuantityForm-${sectionId}`);
    for (let selector of selectors) {
      const current = quantityForm.querySelector(selector);
      const updated = quantityFormUpdated.querySelector(selector);
      if (!current || !updated) continue;

      if (selector === ".m-quantity__input") {
        const attributes = [
          "data-cart-quantity",
          "data-min",
          "data-max",
          "step",
        ];
        for (let attribute of attributes) {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            current.setAttribute(attribute, valueUpdated);
          } else {
            current.removeAttribute(attribute);
          }
        }
      } else {
        current.innerHTML = updated.innerHTML;
      }
    }
  }

  setQuantityBoundries(sectionId, productId) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;

    const data = {
      cartQuantity: this.input.hasAttribute("data-cart-quantity")
        ? parseInt(this.input.getAttribute("data-cart-quantity"))
        : 0,
      min: this.input.hasAttribute("data-min") && this.input.getAttribute("data-min")
        ? parseInt(this.input.getAttribute("data-min"))
        : 1,
      max: this.input.hasAttribute("data-max") && this.input.getAttribute("data-max")
        ? parseInt(this.input.getAttribute("data-max"))
        : null,
      step: this.input.hasAttribute("step") && this.input.getAttribute("step")
        ? parseInt(this.input.getAttribute("step"))
        : 1,
    };

    let min = data.min;
    const max = data.max === null ? data.max : data.max - data.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

    this.input.min = min;

    if (max) {
      this.input.max = max;
    } else {
      this.input.removeAttribute("max");
    }
    this.input.value = min;

    MinimogEvents.emit(MinimogTheme.pubSubEvents.quantityUpdate, undefined);
  }

  reset() {
    this.input.value = this.input.defaultValue;
  }

  setValidity(message) {
    this.input.setCustomValidity(message);
    this.input.reportValidity();
    this.input.value = this.input.defaultValue;
    this.input.select();
    // Avoid the button being disabled when enter a value is greater than max value or less than min value
    this.validateQtyRules();
  }
}

customElements.define("m-quantity-input", MQuantityInput);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // Save product Id
    if (isStorageSupported("local")) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = "minimog-recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");

      // Check current product already exists, if not push to array
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // Save to localStorage
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
    }
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    if (this.hasAttribute('style')) return;

    if (this.dataset.from) {
      this.initProgress();
    }

    MinimogTheme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    this.setPercentage(this.dataset.value, this.dataset.max);
  }

  initProgress() {
    this.setPercentage(this.dataset.from, this.dataset.max);
  }

  setPercentage(val1, val2) {
    this.style.setProperty('--percent', `${(parseInt(val1) / parseInt(val2)) * 100}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

if (!customElements.get("m-cart-count")) {
  class MCartCount extends HTMLElement {
    constructor() {
      super();
      this.getSectionToRenderListener = this.getSectionToRender.bind(this);
    }

    cartUpdateUnsubscriber = undefined;

    get sectionName() {
      return 'cart-count';
    }

    getSectionToRender(event) {
      event.detail.sections.push(this.sectionName);
    }

    connectedCallback() {
      document.addEventListener('cart:grouped-sections', this.getSectionToRenderListener);

      this.cartUpdateUnsubscriber = MinimogEvents.subscribe(
        MinimogTheme.pubSubEvents.cartUpdate,
        this.onCartUpdate.bind(this)
      );
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    get itemCount() {
      return parseInt(this.innerText);
    }

    onCartUpdate(event) {
      if (event.cart.errors) return;
      const sectionToRender = new DOMParser().parseFromString(event.cart.sections[this.sectionName], 'text/html');
      this.onUpdate(sectionToRender);
    }

    onUpdate(section) {
      this.innerText = section.querySelector('.m-cart-count').innerText;
      const method = this.itemCount === 0 ? 'add' : 'remove';
      this.classList[method]('m:hidden');
    }
  }
  customElements.define('m-cart-count', MCartCount);
}

/* === ANONYM – ATC button with price (Minimog safe) === */
(function () {
  return;


  function getText(el){
    return el && el.textContent ? el.textContent.trim() : "";
  }

  function first(selectors){
    for (const s of selectors){
      const el = document.querySelector(s);
      const t = getText(el);
      if (t) return t;
    }
    return "";
  }

  function getPrices(){
    const sale = first([
      ".price__sale .price-item--sale",
      ".price-item--sale",
      ".m-price__sale .m-price-item--sale",
      ".product__price .price-item--sale"
    ]);

    const regular = first([
      ".price__sale .price-item--regular",
      ".price-item--regular",
      ".m-price__sale .m-price-item--regular",
      ".product__price .price-item--regular"
    ]);

    const normal = first([
      ".price__regular .price-item--regular",
      ".m-price__regular .m-price-item--regular",
      ".price .price-item"
    ]);

    return {
      newPrice: sale || normal,
      oldPrice: sale ? (regular || "") : ""
    };
  }

  function applyATC(){
  // ✅ Ne s’exécute QUE sur les fiches produit
  if (!document.body.classList.contains('template-product')) return;

  const btn = document.querySelector('.m-product-form button[name="add"]');
  if (!btn) return;

  const { newPrice, oldPrice } = getPrices();
  if (!newPrice) return;

  const key = (oldPrice || "") + "|" + newPrice;
  if (btn.dataset.asAtcKey === key) return;
  btn.dataset.asAtcKey = key;

btn.innerHTML = oldPrice
  ? '<span class="asAtcWrap"><span class="asAtcText">AJOUTER AU PANIER</span><span class="asAtcOld">'+oldPrice+'</span><span class="asAtcNew">'+newPrice+'</span></span>'
  : '<span class="asAtcWrap"><span class="asAtcText">AJOUTER AU PANIER</span><span class="asAtcOnly">'+newPrice+'</span></span>';
  
 }


  function boot(){
    applyATC();

    // Réapplique pendant 3s (Minimog réécrit parfois le DOM)
    let i = 0;
    const iv = setInterval(() => {
      applyATC();
      i++;
      if (i > 30) clearInterval(iv);
    }, 100);

    // Observe les changements (variantes)
    const mo = new MutationObserver(() => applyATC());
    mo.observe(document.body, { childList: true, subtree: true });

    document.addEventListener("change", () => {
      setTimeout(applyATC, 80);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

})();

/* =========================================
   ANONYM — Sheet Variantes Premium (Cartes)
   + (€/g) sur fiche produit
   + prix barré + économie + meilleur deal + économie vs plus petite
  ========================================= */
(function(){
  return;
  // ---------- Helpers format FR ----------
  const moneyFR = (cents) => (cents/100).toLocaleString('fr-FR',{minimumFractionDigits:2, maximumFractionDigits:2}) + '€';
  const numFR = (n) => n.toLocaleString('fr-FR',{minimumFractionDigits:2, maximumFractionDigits:2});
  const pctRound = (n) => Math.round(n);

  // capte "3g", "3 g", "100G"
  const getGrams = (txt) => {
    if(!txt) return null;
    const m = String(txt).replace(',', '.').match(/(\d+(?:\.\d+)?)\s*g\b/i);
    return m ? parseFloat(m[1]) : null;
  };

  const perGFR = (cents, grams) => {
  const txt = document.body.innerText.toLowerCase();

  if (
    txt.includes('conditionnement') ||
    txt.includes('paquet') ||
    txt.includes('feuilles') ||
    txt.includes('filtres') ||
    txt.includes('accessoire') ||
    txt.includes('accessoires')
  ) {
    return '';
  }

  if (!grams || grams <= 0) return '';

  const v = (cents / 100) / grams;
  return numFR(v) + '€/g';
};

  // Tri "naturel" par grammes
  const sortByGrams = (a, b) => {
    const ga = getGrams(a.public_title || a.title || a.option1) ?? 999999;
    const gb = getGrams(b.public_title || b.title || b.option1) ?? 999999;
    if(ga !== gb) return ga - gb;
    return (a.position||0) - (b.position||0);
  };

  const fetchProduct = async (handle) => {
    const res = await fetch(`/products/${handle}.js`, {credentials:'same-origin'});
    if(!res.ok) throw new Error('product fetch failed');
    return await res.json();
  };

  const addToCart = async (variantId, qty=1) => {
    const res = await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: variantId, quantity: qty}),
      credentials:'same-origin'
    });
    if(!res.ok) throw new Error('add failed');
    return await res.json();
  };

  // ---------- Handle finder (cartes) ----------
  const getHandleNear = (el) => {
    const root = el.closest('article, .m-product-card, .product-card, .card, [data-product-handle]') || el.closest('a');
    if(!root) return null;

    const direct = root.getAttribute && root.getAttribute('data-product-handle');
    if(direct) return direct;

    const link = root.querySelector ? root.querySelector('a[href*="/products/"]') : null;
    const href = link ? link.getAttribute('href') : (root.getAttribute ? root.getAttribute('href') : null);
    if(!href) return null;

    const m = href.match(/\/products\/([^\/\?\#]+)/);
    return m ? m[1] : null;
  };

  // ---------- UI mount ----------
  const back = document.createElement('div');
  back.className = 'asSheetBack';

  const sheet = document.createElement('div');
  sheet.className = 'asSheet';
  sheet.innerHTML = `
    <div class="asSheetHead">
      <div class="asSheetTitleWrap">
        <div class="asSheetTitle">Choisir une quantité</div>
        <div class="asSheetSub">Prix /g • Promo • Ajout rapide</div>
      </div>
      <div class="asSheetClose" aria-label="Fermer">✕</div>
    </div>
    <div class="asSheetBody"></div>
  `;

  const mount = () => {
    if(document.querySelector('.asSheet')) return;
    document.body.appendChild(back);
    document.body.appendChild(sheet);
    back.addEventListener('click', closeSheet);
    sheet.querySelector('.asSheetClose').addEventListener('click', closeSheet);
  };

  const openSheet = () => {
    back.style.display = 'block';
    sheet.style.display = 'block';
    document.documentElement.style.overflow = 'hidden';
  };
  const closeSheet = () => {
    back.style.display = 'none';
    sheet.style.display = 'none';
    document.documentElement.style.overflow = '';
    sheet.querySelector('.asSheetBody').innerHTML = '';
  };

  // ---------- Render sheet ----------
  const renderSheet = (product) => {
    const body = sheet.querySelector('.asSheetBody');
    const title = sheet.querySelector('.asSheetTitle');
    const sub = sheet.querySelector('.asSheetSub');

    title.textContent = (product.title || 'Choisir une quantité').toUpperCase();

    let variants = (product.variants || []).slice().sort(sortByGrams);

    // base = plus petite quantité dispo avec grammes
    const smallest = variants
      .map(v => ({v, g: getGrams(v.public_title || v.title || v.option1)}))
      .filter(x => x.g && x.v.available)
      .sort((a,b)=>a.g-b.g)[0];

    // best deal = meilleur €/g dispo
    const best = variants
      .map(v => {
        const g = getGrams(v.public_title || v.title || v.option1);
        const per = (g && v.available) ? (v.price/g) : null; // cents per g
        return {v, g, per};
      })
      .filter(x => x.per !== null)
      .sort((a,b)=>a.per-b.per)[0];

    if(best && best.g){
      const bestPerG = perGFR(best.v.price, best.g);
      sub.textContent = `Meilleur deal : ${best.v.public_title || best.v.title} • ${bestPerG}`;
    }else{
      sub.textContent = `Prix /g • Promo • Ajout rapide`;
    }

    body.innerHTML = '';

    variants.forEach(v => {
      const grams = getGrams(v.public_title || v.title || v.option1);
      const pg = grams ? perGFR(v.price, grams) : null;

      const row = document.createElement('div');
      row.className = 'asRow';

      const isBest = best && best.v && (best.v.id === v.id);
      if(isBest) row.classList.add('isBest');

      // LEFT
      const left = document.createElement('div');
      left.className = 'asLeft';

      const qtyLine = document.createElement('div');
      qtyLine.className = 'asQtyLine';

      const qty = document.createElement('div');
      qty.className = 'asQty';
      qty.textContent = v.public_title || v.title;

      qtyLine.appendChild(qty);

      if(isBest){
        const tag = document.createElement('div');
        tag.className = 'asTag asTagBest';
        tag.textContent = 'MEILLEUR DEAL';
        qtyLine.appendChild(tag);
      }else if(v.compare_at_price && v.compare_at_price > v.price){
        const tag = document.createElement('div');
        tag.className = 'asTag';
        const saveCents = v.compare_at_price - v.price;
        const pct = pctRound((saveCents / v.compare_at_price) * 100);
        tag.textContent = `PROMO -${pct}%`;
        qtyLine.appendChild(tag);
      }

      const per = document.createElement('div');
      per.className = 'asPerG';
      per.textContent = pg ? `(${pg})` : '';

      left.appendChild(qtyLine);
      left.appendChild(per);

      // économie vs plus petite quantité
      if(smallest && smallest.g && grams && grams > 0 && v.available){
        const basePer = smallest.v.price / smallest.g;     // cents per g
        const thisPer = v.price / grams;                   // cents per g
        const savePerG = basePer - thisPer;                // cents per g
        const saveTotalCents = Math.max(0, Math.round(savePerG * grams));
        if(saveTotalCents > 0){
          const vs = document.createElement('div');
          vs.className = 'asVsSmall';
          vs.textContent = `Économie vs ${smallest.v.public_title || smallest.v.title} : ${moneyFR(saveTotalCents)}`;
          left.appendChild(vs);
        }
      }

      // RIGHT
      const right = document.createElement('div');
      right.className = 'asRight';

      const priceWrap = document.createElement('div');
      priceWrap.className = 'asPriceWrap';

      // Compare / now / save
      if(v.compare_at_price && v.compare_at_price > v.price){
        const compare = document.createElement('div');
        compare.className = 'asCompare';
        compare.textContent = moneyFR(v.compare_at_price);
        priceWrap.appendChild(compare);
      }

      const now = document.createElement('div');
      now.className = 'asNow';
      now.textContent = moneyFR(v.price);
      priceWrap.appendChild(now);

      if(v.compare_at_price && v.compare_at_price > v.price){
        const save = document.createElement('div');
        save.className = 'asSave';
        const saveCents = v.compare_at_price - v.price;
        const pct = pctRound((saveCents / v.compare_at_price) * 100);
        save.textContent = `Économie ${numFR(saveCents/100)}€ (-${pct}%)`;
        priceWrap.appendChild(save);
      }

      const btn = document.createElement('button');
      btn.className = 'asBtn ' + (v.available ? 'asBtnAdd' : 'asBtnOff');
      btn.textContent = v.available ? 'Ajouter' : 'Indispo';
      btn.disabled = !v.available;

      btn.addEventListener('click', async () => {
        if(!v.available) return;
        const old = btn.textContent;
        try{
          btn.textContent = '...';
          await addToCart(v.id, 1);
          btn.textContent = 'Ajouté ✓';
          setTimeout(closeSheet, 350);
        }catch(e){
          btn.textContent = 'Erreur';
          setTimeout(()=>btn.textContent = old, 900);
        }
      });

      right.appendChild(priceWrap);
      right.appendChild(btn);

      row.appendChild(left);
      row.appendChild(right);
      body.appendChild(row);
    });

    openSheet();
  };

  // ---------- CARTES (TOUTES SECTIONS) : clic sur une carte produit ----------
document.addEventListener('click', async (e) => {
  mount();

  // Sur fiche produit : autoriser la sheet uniquement dans "Vous aimerez sûrement"
if (document.body.classList.contains('template-product')) {
  const inReco = e.target && e.target.closest && e.target.closest(
    '.product-recommendations, .m-product-recommendations, .m-recommendations, [id*="product-recommendations"], [data-section-type*="recommend"]'
  );
  if (!inReco) return;
}


  const t = e.target;
  if(!t) return;

  // On détecte une CARTE PRODUIT (marche aussi dans "Vous aimerez sûrement")
  

  // On déclenche seulement si l’utilisateur clique sur le bouton "options" OU sur le select
  const btn = t.closest && t.closest('button, a, [role="button"]');
  const txt = ((btn && btn.textContent) ? btn.textContent : (t.textContent || '')).trim().toLowerCase();

  const clickedOptions = txt.includes('option') || txt.includes('choisir') || txt.includes('sélectionn') || txt.includes('select');
  const clickedSelect = (t.matches && t.matches('select')) || (btn && btn.querySelector && btn.querySelector('select'));

  if(!clickedOptions && !clickedSelect) return;

  // On évite de casser "Ajouter au panier" direct si présent
  if(txt.includes('ajouter au panier')) return;

  let handle = null;

// Depuis le bouton cliqué
const hrefBtn = btn.getAttribute('href') || '';
let m = hrefBtn.match(/\/products\/([^\/\?\#]+)/);

if(m){
  handle = m[1];
}

// Fallback : chercher autour
if(!handle){
  const wrap = btn.closest('section, div, article, li, .swiper-slide');
  const link = wrap && wrap.querySelector('a[href*="/products/"]');

  if(link){
    const href = link.getAttribute('href') || '';
    m = href.match(/\/products\/([^\/\?\#]+)/);
    if(m) handle = m[1];
  }
}

if(!handle) return;


  e.preventDefault();
  e.stopPropagation();

  try{
    const product = await fetchProduct(handle);
    renderSheet(product);
  }catch(err){
    console.warn('ANONYM sheet error', err);
  }
}, true);


  // ---------- FICHE PRODUIT : ajoute (€/g) dans les options des selects ----------
  const enhanceProductDropdown = async () => {
    if(!document.body.classList.contains('template-product')) return;

    const m = location.pathname.match(/\/products\/([^\/\?\#]+)/);
    const handle = m ? m[1] : null;
    if(!handle) return;

    let product;
    try{ product = await fetchProduct(handle); }catch(e){ return; }

    // map : titre -> {price, grams}
    const map = new Map();
    (product.variants || []).forEach(v => {
      const grams = getGrams(v.public_title || v.title || v.option1);
      if(!grams) return;
      const key = (v.public_title || v.title || '').trim().toLowerCase();
      map.set(key, {price: v.price, grams});
    });

    document.querySelectorAll('select').forEach(sel => {
      const looks = [...sel.options].some(o => getGrams(o.textContent));
      if(!looks) return;

      [...sel.options].forEach(opt => {
        const raw = (opt.textContent || '').trim();
        if(/€\/g/i.test(raw)) return;

        const grams = getGrams(raw);
        if(!grams) return;

        const clean = raw.replace(/-.*$/,'').trim();
        const key = clean.toLowerCase();

        // match "contient"
        let found = null;
        for (const [k,v] of map.entries()){
          if(k && key.includes(k)) { found = v; break; }
        }
        if(!found){
          // match inverse
          for (const [k,v] of map.entries()){
            if(k && k.includes(key)) { found = v; break; }
          }
        }
        if(found){
          const pg = perGFR(found.price, found.grams || grams);
          if(pg) opt.textContent = `${raw} (${pg})`;
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', enhanceProductDropdown);
})();

/* =========================================================
  ANONYM — Renomme "Sélectionnez les options" -> "Choisir mon format"
  (cartes, sliders, "Vous aimerez sûrement", etc.)
========================================================= */
(function () {
  const NEW_TEXT = "VOIR LE PRODUIT"; 
  // Si tu veux VRAIMENT forcer en majuscules dans le texte :
  // const NEW_TEXT = "CHOISIR MON FORMAT";

  const matchTexts = [
    "sélectionnez les options",
    "selectionnez les options",
    "choisir les options",
    "select options",
    "choose options",
    "choose option"
  ];

  function isMatch(str) {
    if (!str) return false;
    const t = String(str).replace(/\s+/g, " ").trim().toLowerCase();
    return matchTexts.some(m => t.includes(m));
  }

  function patch(root = document) {
    // Buttons + links qui affichent ce texte
    const nodes = root.querySelectorAll('button, a, [role="button"], span');
    nodes.forEach((el) => {
      // On évite de casser les boutons "Ajouter au panier"
      const txt = (el.textContent || "").trim();
      if (!isMatch(txt)) return;
      if ((txt || "").toLowerCase().includes("ajouter")) return;

      // On remplace seulement si c’est vraiment ce libellé
      el.textContent = NEW_TEXT;

      // Bonus accessibilité si c’est un vrai bouton/lien
      if (el.tagName === "A" || el.tagName === "BUTTON" || el.getAttribute("role") === "button") {
        el.setAttribute("aria-label", NEW_TEXT);
      }
    });
  }

  // 1) Au chargement
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => patch(document));
  } else {
    patch(document);
  }

  // 2) Sur contenus injectés (sliders, recommandations, quick shop)
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((n) => {
          if (n.nodeType === 1) patch(n);
        });
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();


/* === ANONYM: Force refresh cart after any Ajax add === */
(function () {
  const CART_JSON = "/cart.js";

  async function refreshCartUI() {
    try {
      const cart = await fetch(CART_JSON, { credentials: "same-origin" }).then(r => r.json());

      // Met à jour les bulles / compteurs possibles
      const nodes = document.querySelectorAll(
        '[data-cart-count], .m-cart-count-bubble, .cart-count-bubble, .m-cart-count, .header__cart-count'
      );
      nodes.forEach(el => {
        el.textContent = String(cart.item_count);
        el.classList.toggle("hidden", cart.item_count === 0);
        el.classList.toggle("m:hidden", cart.item_count === 0);
      });

      // Envoie plusieurs events (Minimog/Shopify écoutent souvent l’un d’eux)
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
      document.dispatchEvent(new CustomEvent("minimog:cart:updated", { detail: { cart } }));
      document.dispatchEvent(new CustomEvent("minimog:cart:refresh", { detail: { cart } }));
    } catch (e) {
      // silence
    }
  }

  // 1) Hook fetch : dès qu’un /cart/add passe, on refresh
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    return _fetch.apply(this, args).then(res => {
      try {
        const url = (typeof args[0] === "string" ? args[0] : (args[0] && args[0].url)) || "";
        if (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update")) {
          setTimeout(refreshCartUI, 150);
          setTimeout(refreshCartUI, 900); // 2e refresh (au cas où un drawer se met à jour en retard)
        }
      } catch (e) {}
      return res;
    });
  };

  // 2) Backup : si un form /cart/add submit, refresh aussi
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (form && form.tagName === "FORM" && form.action && form.action.includes("/cart/add")) {
        setTimeout(refreshCartUI, 250);
        setTimeout(refreshCartUI, 1000);
      }
    },
    true
  );

  document.addEventListener("DOMContentLoaded", refreshCartUI);
})();

/* ===== GLASS EFFECT POPUP (ANONYM) ===== */
(function () {

  const SHEET_BG = 'rgba(255,255,255,0.90)'; // comme panier
  const OVERLAY_BG = 'rgba(0,0,0,0.18)';    // plus light

  function applyGlassEffect() {

    // Popup principale
    document.querySelectorAll('.asSheet').forEach(sheet => {

      sheet.style.setProperty('background', SHEET_BG, 'important');
      sheet.style.setProperty('-webkit-backdrop-filter','blur(26px) saturate(180%)','important');
      sheet.style.setProperty('backdrop-filter','blur(26px) saturate(180%)','important');
sheet.style.setProperty('border','1px solid rgba(255,255,255,0.60)','important');
sheet.style.setProperty('border-radius','22px','important');
sheet.style.setProperty('box-shadow','0 20px 45px rgba(0,0,0,0.10)','important');

    // Styles internes (garder des sections blanches comme panier)
sheet.querySelectorAll('.asSheetHead').forEach(el => {
  el.style.setProperty('background','rgba(255,255,255,0.75)','important');
  el.style.setProperty('border-bottom','1px solid rgba(255,255,255,0.50)','important');
});

sheet.querySelectorAll('.asSheetBody').forEach(el => {
  el.style.setProperty('background','transparent','important'); // on laisse respirer
});

// Cartes/sections à l’intérieur (format, lignes, blocs)
sheet.querySelectorAll('.asOption, .asRow, .asCard, .m-product-option, .variant, .option').forEach(el => {
  el.style.setProperty('background','rgba(255,255,255,0.85)','important');
  el.style.setProperty('border','1px solid rgba(255,255,255,0.70)','important');
  el.style.setProperty('border-radius','18px','important');
  el.style.setProperty('box-shadow','0 10px 22px rgba(0,0,0,0.10)','important');
});  
    });

    // Fond sombre derrière
    document.querySelectorAll('.asSheetBack').forEach(back => {
      back.style.setProperty('background', OVERLAY_BG, 'important');
    });
  }

  // Appliquer au chargement + retenter
  document.addEventListener('DOMContentLoaded', applyGlassEffect);
  setTimeout(applyGlassEffect, 500);
  setTimeout(applyGlassEffect, 1500);

  // Observer les popups dynamiques
  const observer = new MutationObserver(applyGlassEffect);
  observer.observe(document.body, { childList: true, subtree: true });

})();

/* ===== POPUP: TITRE + LIEN "VOIR DESCRIPTION" (URL EXACTE AU CLIC) ===== */
(function () {
  // Stocke l'URL du produit réellement cliqué
  window.__asLastProductUrl = window.__asLastProductUrl || '';

  // Capture ultra fiable : dès qu'on clique/touche un lien "Choisir format" (ou un lien produit)
  function captureProductUrl(e) {
    const a = e.target.closest('a[href*="/products/"]');
    if (!a) return;

    const txt = (a.textContent || '').trim().toLowerCase();
    const aria = (a.getAttribute('aria-label') || '').toLowerCase();

    // On privilégie "Choisir format" / bouton produit Minimog
    const isChooser =
      txt.includes('choisir') ||
      aria.includes('choisir') ||
      a.classList.contains('m-product-form') ||
      a.className.includes('m-product-form') ||
      a.className.includes('m-button');

    // Si c'est un lien produit (même sans "choisir"), on peut aussi le garder
    if (isChooser || a.href.includes('/products/')) {
      window.__asLastProductUrl = a.href;
    }
  }

  // Pointerdown = top sur mobile + desktop (avant même le click)
  document.addEventListener('pointerdown', captureProductUrl, true);
  document.addEventListener('click', captureProductUrl, true);

  function findBestTitle(head) {
    // On cherche un élément texte dans le header qui n'est pas "Meilleur deal"
    const nodes = head.querySelectorAll('h1,h2,h3,h4,strong,b,div,span,p');
    for (const n of nodes) {
      const t = (n.textContent || '').trim();
      if (!t) continue;
      if (t.toLowerCase().includes('meilleur deal')) continue;
      if (t.length < 3 || t.length > 40) continue;
      return n;
    }
    return null;
  }

  function enhancePopup() {
    document.querySelectorAll('.asSheet').forEach(sheet => {
      const head = sheet.querySelector('.asSheetHead');
      if (!head) return;

      // 1) TITRE plus gros
      const title = findBestTitle(head);
      if (title) {
        title.style.setProperty('font-size', '24px', 'important');
        title.style.setProperty('font-weight', '900', 'important');
        title.style.setProperty('letter-spacing', '0.4px', 'important');
        title.style.setProperty('text-transform', 'uppercase', 'important');
        title.style.setProperty('line-height', '1.1', 'important');
      }

      // 2) LIEN "Voir description" (toujours mettre à jour l'URL)
      const url = window.__asLastProductUrl;
      if (!url || !url.includes('/products/')) return;

      let link = sheet.querySelector('.popup-desc-link');
      if (!link) {
        link = document.createElement('a');
        link.className = 'popup-desc-link';
        link.textContent = '➜ Voir la fiche →';

        // Micro-move premium
link.style.transition = 'all 0.25s ease';
link.style.willChange = 'transform, opacity';

function animateIn() {
  link.style.transform = 'translateX(4px)';
  link.style.opacity = '1';
}

function animateOut() {
  link.style.transform = 'translateX(0)';
  link.style.opacity = '0.75';
}

link.addEventListener('mouseenter', animateIn);
link.addEventListener('mouseleave', animateOut);
link.addEventListener('touchstart', animateIn, { passive: true });
link.addEventListener('touchend', animateOut);


        // Style premium (pas vert fluo)
        link.style.setProperty('display', 'inline-block', 'important');
        link.style.setProperty('margin-left', '10px', 'important');
        link.style.setProperty('font-size', '13px', 'important');
        link.style.setProperty('font-weight', '700', 'important');
        link.style.setProperty('color', '#000', 'important');
        link.style.setProperty('opacity', '0.78', 'important');
        link.style.setProperty('text-decoration', 'none', 'important');

        link.addEventListener('mouseenter', () => (link.style.opacity = '1'));
        link.addEventListener('mouseleave', () => (link.style.opacity = '0.78'));

        head.appendChild(link);
      }

      // Toujours mettre l'URL du dernier clic (corrige Tropicana)
      link.href = url;
    });
  }

  setTimeout(enhancePopup, 200);
  setTimeout(enhancePopup, 900);

  const obs = new MutationObserver(enhancePopup);
  obs.observe(document.body, { childList: true, subtree: true });
})();

/* =========================================================
   ANONYM — Badge -% + €/g (auto, sur toutes les cartes)
========================================================= */
(function () {
  const CACHE = new Map();
  let running = false;

  const moneyPerG = (v) => "";

  function gramsFromText(t) {
    if (!t) return null;
    const s = String(t).toLowerCase().replace(",", ".");
    const m = s.match(/(\d+(?:\.\d+)?)\s*(g|gr|gramme|grammes)\b/);
    if (!m) return null;
    const n = parseFloat(m[1]);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  async function getProduct(handle) {
    if (CACHE.has(handle)) return CACHE.get(handle);
    const p = fetch(`/products/${handle}.js`)
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null);
    CACHE.set(handle, p);
    return p;
  }

  function compute(product) {
    let bestPerG = null;
    let maxPct = null;

    for (const v of product.variants || []) {
      const g =
        gramsFromText(v.public_title) ||
        gramsFromText(v.title) ||
        gramsFromText((v.options || []).join(" "));
      if (!g) continue;

      const price = (v.price || 0) / 100;
      if (!price) continue;

      const perG = price / g;
      if (bestPerG === null || perG < bestPerG) bestPerG = perG;

      const compare = (v.compare_at_price || 0) / 100;
      if (compare && compare > price) {
        const pct = Math.round(((compare - price) / compare) * 100);
        if (maxPct === null || pct > maxPct) maxPct = pct;
      }
    }

    return {
      perGLabel: bestPerG !== null ? moneyPerG(bestPerG) : null,
      pct: maxPct
    };
  }

  function getHandle(card) {
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const href = a.getAttribute("href") || "";
    const m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function ensureRelative(card) {
    const media =
      card.querySelector(".m-product-card__media, .m-card-product__media, .product-card__media") ||
      card.querySelector("figure") ||
      card;
    if (media && getComputedStyle(media).position === "static") {
      media.style.position = "relative";
    }
    return media || card;
  }

  function injectPerG(card, perGLabel) {
    if (!perGLabel) return;

    // évite doublon
    if (card.querySelector(".as-perg")) return;

    const priceWrap =
      card.querySelector(".m-price, .price, .m-product-price, .product-price, [data-price]") ||
      card;

    const el = document.createElement("div");
    el.className = "as-perg";
    el.textContent = `${perGLabel}`;
    priceWrap.appendChild(el);
  }

  function injectBadge(card, pct, perGLabel) {
    if (!pct && !perGLabel) return;

    const txt = `${pct ? `-${pct}%` : ""}`.trim();
    if (!txt) return;

    

    // Bonus: si un badge natif "-50%" existe, on le complète aussi
    const native = Array.from(card.querySelectorAll(".m-product-tag, .m-badge, .badge, .product-tag"))
      .find(el => (el.textContent || "").includes("%"));
    if (native && !(native.textContent || "").includes("€ / g")) {
      native.textContent = txt;
    }
  }

  function findCards() {
    const links = Array.from(document.querySelectorAll('a[href*="/products/"]'));
    const cards = new Set();
    for (const a of links) {
      const card = a.closest(".m-product-card, .m-card-product, .product-card, .m-product-item, .card") || a;
      cards.add(card);
    }
    return Array.from(cards);
  }

  async function run() {
    if (running) return;
    running = true;

    const cards = findCards();

    for (const card of cards) {
      // évite de recalculer si déjà fait
      if (card.dataset.asPergDone === "1") continue;

      const handle = getHandle(card);
      if (!handle) continue;

      const product = await getProduct(handle);
      if (!product) continue;

      const { perGLabel, pct } = compute(product);

      injectPerG(card, perGLabel);
      injectBadge(card, pct, perGLabel);

      card.dataset.asPergDone = "1";
    }

    running = false;
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);

  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();


document.querySelectorAll('.sale-badge, .product-badge').forEach(badge => {
  badge.textContent = badge.textContent.replace(/·.*€/g, '').trim();
});

(function () {
  function cleanBadges() {
    document
      .querySelectorAll('.m-product-card__tag-name.m-product-tag--sale')
      .forEach(function (el) {
        var t = el.textContent || '';
        var m = t.match(/-?\s*\d+\s*%/);
        if (m) {
          el.textContent = m[0].replace(/\s+/g, '');
        }
      });
  }

  // Lance plusieurs fois pour attraper le lazy-load
  cleanBadges();
  setTimeout(cleanBadges, 500);
  setTimeout(cleanBadges, 1500);
  setTimeout(cleanBadges, 3000);
})();

/* ===============================
   FORCE PILLS COLOR MOBILE iOS
=============================== */

function fixAnonymPills() {
  document.querySelectorAll('.anonym-pill').forEach(pill => {
    pill.style.background = '#f2f2f2';
    pill.style.color = '#111';
    pill.style.border = '1px solid #ccc';
  });
}

// Au chargement
document.addEventListener('DOMContentLoaded', fixAnonymPills);

// Après chargement complet
window.addEventListener('load', fixAnonymPills);

// Quand Minimog recharge les cards
setInterval(fixAnonymPills, 800);

/* ANONYM — Pills full width (mobile) */
(function () {
  function anonymPillsFullWidth() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    document.querySelectorAll('.anonym-card-meta').forEach(meta => {
      if (!isMobile) return;

      meta.style.display = 'flex';
      meta.style.width = '100%';
      meta.style.gap = '8px';

      meta.querySelectorAll('.anonym-pill').forEach(pill => {
        pill.style.flex = '1 1 0';
        pill.style.minWidth = '0';
        pill.style.justifyContent = 'center';
        pill.style.textAlign = 'center';
      });
    });
  }

  window.addEventListener('load', anonymPillsFullWidth);
  window.addEventListener('resize', anonymPillsFullWidth);

  // si Minimog recharge les cartes en lazy/slider
  setInterval(anonymPillsFullWidth, 800);
})();

/* ANONYM — Fiche produit: étirer les asBadge (SAFE mobile/PC) */
(function () {
  function stretchAsBadges() {
    if (!document.body.classList.contains('template-product')) return;

    // On ne touche qu'aux vrais badges
    const badges = Array.from(document.querySelectorAll('.asBadge'));
    if (!badges.length) return;

    // On cherche le conteneur le plus logique : le parent commun qui contient plusieurs .asBadge
    const containers = new Set();
    badges.forEach(b => {
      const c = b.closest('.asBadges__main') || b.parentElement;
      if (c) containers.add(c);
    });

    containers.forEach(wrap => {
      // Ne pas casser la mise en page si ce n'est pas un wrap de badges
      if (!wrap.querySelector('.asBadge')) return;

      // Container full width
      wrap.style.setProperty('display', 'flex', 'important');
      wrap.style.setProperty('width', '100%', 'important');
      wrap.style.setProperty('max-width', '100%', 'important');
      wrap.style.setProperty('gap', '8px', 'important');
      wrap.style.setProperty('align-items', 'center', 'important');
      wrap.style.setProperty('flex-wrap', 'nowrap', 'important');

      // Chaque badge s'étire (50/50 s’il y en a 2)
      wrap.querySelectorAll('.asBadge').forEach(b => {
        b.style.setProperty('flex', '1 1 0', 'important');
        b.style.setProperty('min-width', '0', 'important');
        b.style.setProperty('max-width', 'none', 'important');
        b.style.setProperty('width', 'auto', 'important'); // <-- important: ne pas forcer 100%
        b.style.setProperty('text-align', 'center', 'important');
      });
    });
  }

  window.addEventListener('load', stretchAsBadges);
  window.addEventListener('resize', stretchAsBadges);

  // Minimog peut rerender en mobile
  const obs = new MutationObserver(() => stretchAsBadges());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  setInterval(stretchAsBadges, 900);
})();

(function () {
  const STYLE_ID = "anonym-mobile-pill-fix";

  function isMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  function injectOrUpdate() {
    let el = document.getElementById(STYLE_ID);

    // Si pas mobile -> on retire l’override
    if (!isMobile()) {
      if (el) el.remove();
      return;
    }

    const css = `
      /* ANONYM: pills moins arrondis sur mobile */
      .anonym-pill,
      .m-product-card .anonym-pill,
      .template-product .asBadges .asBadge {
        border-radius: 4px !important;
      }
    `;

    if (!el) {
      el = document.createElement("style");
      el.id = STYLE_ID;
      el.type = "text/css";
      document.head.appendChild(el);
    }
    el.textContent = css;
  }

  // 1) au chargement
  document.addEventListener("DOMContentLoaded", injectOrUpdate);

  // 2) quand iPhone tourne / resize
  window.addEventListener("resize", injectOrUpdate);
  window.addEventListener("orientationchange", injectOrUpdate);

  // 3) Shopify (sections qui se rechargent)
  document.addEventListener("shopify:section:load", injectOrUpdate);
  document.addEventListener("shopify:section:select", injectOrUpdate);

  // 4) sécurité: au cas où le thème remplace le head
  setTimeout(injectOrUpdate, 800);
})();

/* ANONYM — Force H1 collection en gras (mobile) */
(function () {
  function run() {
    // seulement mobile
    if (window.matchMedia('(min-width: 769px)').matches) return;

    // pages collection / categories
    if (!document.body.classList.contains('template-collection')) return;

    // cible les titres possibles (Minimog varie selon sections)
    const targets = [
      document.querySelector('.m-page-title'),
      document.querySelector('.m-collection-hero__title'),
      document.querySelector('h1')
    ].filter(Boolean);

    targets.forEach(el => {
      el.style.fontWeight = '900';
      // “faux-gras” propre si iOS refuse le vrai bold
      el.style.textShadow = '0.25px 0 0 currentColor, -0.25px 0 0 currentColor';
    });
  }

  // 1) au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // 2) au cas où le thème remonte le DOM après (lazy sections)
  window.addEventListener('load', run);

  // 3) si tu changes filtre/tri sans recharger (AJAX)
  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

/* =========================================================
   ANONYM • Minimog Drawer: menu en 1 écran (Boutique déplié + pages + compte)
   - Boutique reste cliquable
   - Catégories Boutique injectées sous Boutique (sans niveau / sans flèche retour)
========================================================= */
(function () {
  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function getDrawer() {
    return document.querySelector('#m-menu-drawer');
  }

  function getNav(drawer) {
    return drawer?.querySelector('navigation.m-menu-mobile, nav.m-menu-mobile, .m-menu-mobile');
  }

  function findBoutiqueLi(nav) {
    const items = nav.querySelectorAll('li.m-menu-mobile__item');
    for (const li of items) {
      const label = li.querySelector('a.m-menu-mobile__link span')?.textContent;
      if (norm(label) === 'boutique') return li;
    }
    return null;
  }

  function buildLi(href, text) {
    const li = document.createElement('li');
    li.className = 'm-menu-mobile__item m-menu-mobile__item--no-submenu anonym-flat';
    li.setAttribute('data-url', href);

    const a = document.createElement('a');
    a.className = 'm-menu-mobile__link';
    a.href = href;

    const span = document.createElement('span');
    span.textContent = text;

    a.appendChild(span);
    li.appendChild(a);
    return li;
  }

  function flattenBoutique(drawer) {
    const nav = getNav(drawer);
    if (!nav) return;

    // Évite doublon
    if (nav.querySelector('li.anonym-flat')) return;

    const boutiqueLi = findBoutiqueLi(nav);
    if (!boutiqueLi) return;

    // Récupère les liens du sous-menu Boutique existant
    const submenu = boutiqueLi.querySelector('.m-megamenu-mobile--level-1, .m-megamenu-mobile');
    if (!submenu) return;

    const links = Array.from(submenu.querySelectorAll('a'))
      .map(a => ({
        href: a.getAttribute('href'),
        text: a.textContent.replace(/\s+/g, ' ').trim()
      }))
      .filter(x => x.href && x.text);

    // Masque la flèche/chevron de Boutique (toggle)
    const toggle = boutiqueLi.querySelector('.m-menu-mobile__toggle-button,[data-toggle-submenu],[data-toggle-submenu="1"]');
    if (toggle) toggle.style.display = 'none';

    // Empêche le thème de rentrer dans le niveau Boutique (on garde Boutique cliquable)
    boutiqueLi.classList.add('anonym-boutique-flat');
    submenu.style.display = 'none';

    // Injecte les catégories sous Boutique (indentées via CSS)
    const parentUL = boutiqueLi.parentElement; // <ul>
    let insertAfter = boutiqueLi;

    links.forEach(l => {
      const li = buildLi(l.href, l.text);
      insertAfter.after(li);
      insertAfter = li;
    });

    // Cache la flèche retour (si le thème l’affiche)
    const back = drawer.querySelector('.m-menu-mobile__back, .m-menu-mobile__header-back, [data-menu-back]');
    if (back) back.style.display = 'none';
  }

  function run() {
    const drawer = getDrawer();
    if (!drawer) return;
    if (!drawer.classList.contains('open')) return;
    setTimeout(() => flattenBoutique(drawer), 120);
  }

  function init() {
    const drawer = getDrawer();
    if (!drawer) return;

    // À chaque ouverture du drawer
    const obs = new MutationObserver(run);
    obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // Sécurité
    setTimeout(run, 800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =========================================================
   ANONYM • Drawer menu: MAJ + GRAS + BOUTIQUE PLUS GROS
========================================================= */
(function () {
  const APPLY_DELAY = 80;

  function applyMenuStyle(drawer) {
    if (!drawer || !drawer.classList.contains('open')) return;

    const nav = drawer.querySelector('.m-menu-mobile');
    if (!nav) return;

    const links = nav.querySelectorAll(
      '.m-menu-mobile__link, li.m-menu-mobile__item a'
    );

    links.forEach((el, index) => {
      if (!el || !el.textContent) return;

      // Style général
      el.style.fontWeight = '700';
      el.style.textTransform = 'uppercase';
      el.style.letterSpacing = '0.04em';

      // 👉 Premier item = Boutique
      if (index === 0) {
        el.style.fontSize = '20px';   // Taille Boutique
        el.style.fontWeight = '800';
        el.style.marginBottom = '8px';
      } else {
        el.style.fontSize = '15px';   // Autres items
      }
    });
  }

  function init() {
    const drawer = document.querySelector('#m-menu-drawer');
    if (!drawer) return;

    const obs = new MutationObserver(() => {
      if (drawer.classList.contains('open')) {
        setTimeout(() => applyMenuStyle(drawer), APPLY_DELAY);
        setTimeout(() => applyMenuStyle(drawer), 250);
        setTimeout(() => applyMenuStyle(drawer), 900);
      }
    });

    obs.observe(drawer, { attributes: true });

    const obs2 = new MutationObserver(() => {
      if (drawer.classList.contains('open')) {
        applyMenuStyle(drawer);
      }
    });

    obs2.observe(drawer, { childList: true, subtree: true });

    setTimeout(() => applyMenuStyle(drawer), 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================
   MENU MOBILE — RESSERRER ESPACE ENTRE LIENS
   (Minimog / drawer menu)
============================ */
(function () {
  // Réglages (tu peux ajuster)
  const PAD_Y = "8px";   // mets "6px" si tu veux encore plus serré
  const LINE_H = "1.2";

  const selectors = [
    ".menu-drawer a",
    ".mobile-menu a",
    ".drawer-menu a",
    ".menu-drawer__menu-item",
    ".m-menu-mobile a",          // Minimog souvent
    ".m-menu a",
    ".m-mega-menu a"
  ].join(",");

  function tighten() {
    document.querySelectorAll(selectors).forEach((el) => {
      // On force en inline pour passer au-dessus du thème
      el.style.paddingTop = PAD_Y;
      el.style.paddingBottom = PAD_Y;
      el.style.lineHeight = LINE_H;
    });
  }

  // 1) au chargement
  document.addEventListener("DOMContentLoaded", tighten);

  // 2) à chaque clic (souvent le menu se reconstruit à l’ouverture)
  document.addEventListener("click", function (e) {
    const t = e.target;
    if (!t) return;

    // clic sur burger / ouverture drawer
    if (t.closest('[aria-controls*="menu"], .m-header__menu, .m-menu, .header__icon--menu, button[aria-label*="menu"]')) {
      setTimeout(tighten, 50);
      setTimeout(tighten, 200);
      setTimeout(tighten, 500);
    }
  });

  // 3) observer DOM (quand le thème injecte/remplace le menu)
  const obs = new MutationObserver(() => {
    tighten();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  const MOBILE_MAX = 990;

  // Le menu (drawer) de Minimog : on évite de toucher à tout ce qui est dedans
  const DRAWER_SELECTORS = [
    '.m-menu-drawer',
    '.m-drawer',
    '.m-mobile-menu',
    '#m-menu-drawer',
    '[data-menu-drawer]'
  ];

  const RIGHT_WRAP_SELECTORS = [
    '.m-header__mobile-right',
    '.m-header__right',
    '.m-header__icons',
    '.m-header__actions',
    '.m-header__mobile-actions'
  ];

  const CART_SELECTORS = [
    '.m-header__cart',
    'a[href*="/cart"]',
    '[data-cart-trigger]',
    '[data-open-cart]'
  ];

  const ACCOUNT_ICON_SELECTORS = [
    '.m-header__account',        // icône compte Minimog
    '.m-header__account-icon',   // variantes possibles
    'a[href*="/account"]'
  ];

  const BADGE_SELECTORS = [
    '.m-cart-count',
    '.m-cart-count--bubble',
    '.cart-count-bubble',
    '.cart-count'
  ];

  function findFirst(root, selectors) {
    for (const sel of selectors) {
      const el = root.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function isInsideAnyDrawer(el) {
    if (!el) return false;
    for (const sel of DRAWER_SELECTORS) {
      const drawer = document.querySelector(sel);
      if (drawer && drawer.contains(el)) return true;
    }
    return false;
  }

  function apply() {
    if (window.innerWidth > MOBILE_MAX) return;

    const header = document.querySelector('#m-header, .m-header');
    if (!header) return;

    let rightWrap = findFirst(header, RIGHT_WRAP_SELECTORS);
    if (!rightWrap) return;

    const cartEl = findFirst(header, CART_SELECTORS);
    if (!cartEl) return;

    // On cherche l’icône Compte DU HEADER (et surtout pas celle du menu)
    let accountEl = null;
    const candidates = header.querySelectorAll(ACCOUNT_ICON_SELECTORS.join(','));
    candidates.forEach((c) => {
      if (!accountEl && !isInsideAnyDrawer(c)) accountEl = c;
    });

    // Si on n’a pas trouvé l’icône compte dans le header : on ne casse rien
    if (!accountEl) return;

    // Force un layout propre à droite
    rightWrap.style.display = 'flex';
    rightWrap.style.alignItems = 'center';
    rightWrap.style.justifyContent = 'flex-end';
    rightWrap.style.gap = '12px';

    // S’assure que Compte + Panier soient bien visibles et alignés
    [accountEl, cartEl].forEach((el) => {
      el.style.display = 'inline-flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';
      el.style.margin = '0';
      el.style.padding = '0';
      el.style.transform = 'none';
      el.style.lineHeight = '1';
    });

    // IMPORTANT : on ne "déplace" l’icône compte que si elle est déjà dans le header
    // (et on ne touche jamais au drawer)
    if (accountEl.parentElement !== rightWrap) rightWrap.appendChild(accountEl);
    if (cartEl.parentElement !== rightWrap) rightWrap.appendChild(cartEl);

    // Ordre : Compte puis Panier
    accountEl.style.order = '1';
    cartEl.style.order = '2';

    // Badge panier : éviter qu’il décale l’icône
    const badge =
      findFirst(cartEl, BADGE_SELECTORS) ||
      findFirst(header, BADGE_SELECTORS);

    if (badge) {
      cartEl.style.position = 'relative';
      badge.style.position = 'absolute';
      badge.style.right = '-6px';
      badge.style.top = '-6px';
    }
  }

  window.addEventListener('load', apply);
  window.addEventListener('resize', () => setTimeout(apply, 50));

  const obs = new MutationObserver(() => apply());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {

  /* =========================
     1) CSS LOCK (1 seule fois)
  ========================= */

  if (!document.getElementById("as-pill-lock")) {
    const st = document.createElement("style");
    st.id = "as-pill-lock";
    st.textContent = `
      .anonym-pill--culture,
      .anonym-pill--cbd{
        background: var(--as-bg, rgba(242,242,242,1)) !important;
        color: var(--as-txt, #111) !important;
        border: var(--as-bdr, 1px solid rgba(0,0,0,.12)) !important;
        box-shadow: var(--as-sh, none) !important;
        animation: none !important;
        transition: none !important;
      }
    `;
    document.head.appendChild(st);
  }

  // IMPORTANT: on change la version pour forcer la MAJ des styles
  const FLAG = "data-as-v5";


  /* =========================
     Utils
  ========================= */

  function parseCBD(text) {
    const m = String(text || "").match(/(\d+)\s*%/);
    return m ? Math.min(99, Math.max(0, parseInt(m[1], 10))) : null;
  }

  function setVars(el, bg, txt, bdr, sh) {

    const key = `${bg}|${txt}|${bdr}|${sh}`;

    if (el.getAttribute(FLAG) === key) return;

    el.style.setProperty("--as-bg", bg);
    el.style.setProperty("--as-txt", txt);
    el.style.setProperty("--as-bdr", bdr);
    el.style.setProperty("--as-sh", sh);

    el.setAttribute(FLAG, key);
  }


  /* =========================
     MAIN
  ========================= */

  function applyBadges(root) {

    const scope = root || document;


    /* ===== CULTURE ===== */

    const cultures = [];

    if (scope.nodeType === 1 && scope.matches(".anonym-pill--culture")) {
      cultures.push(scope);
    }

    cultures.push(...scope.querySelectorAll(".anonym-pill--culture"));


    cultures.forEach((el) => {

      const card = el.closest(".m-product-card");

      // 1) Texte "global" de la carte pour détecter HUILES/FEUILLES/FILTRES (OK)
      const fullText = (card ? card.innerText : el.innerText || "").toLowerCase();

      // 2) Texte du badge SEUL pour INDOOR/OUTDOOR (anti-bug)
      const pillText = (el.innerText || "").toLowerCase().trim();


      /* 🧴 HUILES → BLEU */
      if (/huile|oil|relax|spectrum/i.test(fullText)) {
        setVars(
          el,
          "#f3f3f3",
          "#111111",
          "1px solid #D6D6D6",
          "none"
        );
        return;
      }

      /* 📄 FEUILLES → SABLE */
      if (/feuille|slim|tips|papier/i.test(fullText)) {
        setVars(
          el,
          "#6e6e6e",
          "#ffffff",
          "1px solid rgba(200,200,200,.6)",
          "0 2px 6px rgba(0,0,0,.3)"
        );
        return;
      }

      /* 🔘 FILTRES → SILVER */
      if (/filtre|filter|charbon|purize/i.test(fullText)) {
        setVars(
          el,
          "#6e6e6e",
          "#ffffff",
          "1px solid rgba(200,200,200,.6)",
          "0 2px 6px rgba(0,0,0,.3)"
        );
        return;
      }

      /* 🌿 INDOOR (uniquement le badge) */
      if (pillText.includes("indoor")) {
        setVars(
          el,
          "#f3f3f3",
          "#111111",
          "1px solid #D6D6D6",
          "none"
        );
        return;
      }

      /* ☀️ OUTDOOR (uniquement le badge) */
      if (pillText.includes("outdoor")) {
        setVars(
          el,
          "#f3f3f3",
          "#111111",
          "1px solid #D6D6D6",
          "none"
        );
        return;
      }

    });


    /* ===== CBD ===== */

    const cbds = [];

    if (scope.nodeType === 1 && scope.matches(".anonym-pill--cbd")) {
      cbds.push(scope);
    }

    cbds.push(...scope.querySelectorAll(".anonym-pill--cbd"));


    cbds.forEach((el) => {

      const cbd = parseCBD(el.innerText);

      if (cbd == null) return;

      /* Vert fixe sans jaune */
      const hue = 115;
      const sat = 85;
      const light = 88 - (cbd / 99) * 45;

      const bg = "rgba(15,20,18,0.85)"; // dark glass

setVars(
  el,
  "#1a1a1a",          // fond Indoor
  "#ffffff",          // texte blanc
  "1px solid #D6D6D6", // bordure néon
  "none"
);



    });

  }


  /* =========================
     INIT
  ========================= */

  document.addEventListener("DOMContentLoaded", () => {

    applyBadges(document);

    setTimeout(() => applyBadges(document), 300);
    setTimeout(() => applyBadges(document), 900);

  });


  /* =========================
     SHOPIFY DYNAMIC
  ========================= */

  let ticking = false;

  const mo = new MutationObserver((mutations) => {

    if (ticking) return;

    ticking = true;

    requestAnimationFrame(() => {

      ticking = false;

      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node && node.nodeType === 1) {
            applyBadges(node);
          }
        }
      }

    });

  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();

/* =========================================================
  ANONYM — DISCOUNT FIELD in MINIMOG CART DRAWER (V1.1)
  - Injecte dans: [data-minimog-cart-discounts]
  - Compatible AJAX (drawer se recharge)
  - Bouton texte BLANC (anti override #111 !important)
  - Applique via /checkout?discount=CODE
========================================================= */
(function () {
  function injectDiscountField() {
    const container = document.querySelector('[data-minimog-cart-discounts]');
    if (!container) return;

    // évite double injection
    if (container.querySelector('[data-anonym-discount]')) return;

    container.innerHTML = `
      <div data-anonym-discount style="margin:14px 0 10px;">
        <label for="anonymDrawerDiscount"
          style="display:block;font-weight:700;margin:0 0 8px;">
          Code promo
        </label>

        <div style="display:flex;gap:10px;align-items:center;">
          <input
            id="anonymDrawerDiscount"
            type="text"
            inputmode="text"
            autocomplete="off"
            placeholder="Ex: BIENVENUE10"
            style="
              flex:1;
              padding:12px 12px;
              border-radius:12px;
              border:1px solid rgba(0,0,0,.15);
              outline:none;
              background:#fff;
            "
          />

          <button
            type="button"
            data-anonym-apply
            style="
              padding:12px 16px;
              border-radius:12px;
              background:#111;
              border:none;
              cursor:pointer;
              font-weight:700;
              min-width:110px;
            "
          >
            <span style="color:#fff !important;">Appliquer</span>
          </button>
        </div>

        <div data-anonym-msg style="margin-top:8px;font-size:12px;opacity:.75;"></div>
      </div>
    `;

    // bind bouton + enter
    const input = container.querySelector('#anonymDrawerDiscount');
    const btn = container.querySelector('[data-anonym-apply]');
    const msg = container.querySelector('[data-anonym-msg]');

    function apply() {
      const code = (input.value || '').trim();
      if (!code) {
        msg.textContent = "Entre un code promo.";
        return;
      }
      msg.textContent = "Application…";
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    }

    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        apply();
      }
    });
  }

  // injection initiale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectDiscountField);
  } else {
    injectDiscountField();
  }

  // réinjection si le drawer se rerender en AJAX
  const mo = new MutationObserver(function () {
    injectDiscountField();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


document.addEventListener("click", function(e){

  const card = e.target.closest(".m-product-option--node");
  if(!card) return;

  const input = card.querySelector("input.m-product-option__input");
  if(!input) return;

  const value = input.value;

  const select = document.querySelector('select[name="id"]');

  if(!select) return;

  const option = [...select.options].find(o => o.text.includes(value));

  if(option){
    select.value = option.value;
    select.dispatchEvent(new Event("change",{bubbles:true}));
  }

});

function forceMobileBadgeText() {
  if (window.innerWidth > 767) return;

  document.querySelectorAll('.m-product-card__tag-name').forEach(el => {
    el.style.setProperty('font-weight', '900', 'important');
    el.style.setProperty('font-family', 'Arial Black, Arial, sans-serif', 'important');
    el.style.setProperty('letter-spacing', '0.2px', 'important');
    el.style.setProperty('font-size', '10px', 'important');
  });
}

document.addEventListener('DOMContentLoaded', forceMobileBadgeText);
window.addEventListener('load', forceMobileBadgeText);
setTimeout(forceMobileBadgeText, 800);
setTimeout(forceMobileBadgeText, 1800);

function movePillsAndContent() {
  const isMobile = window.innerWidth <= 767;
  const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1199;
  const isDesktop = window.innerWidth >= 1200;

  document.querySelectorAll('.anonym-card-meta').forEach((el) => {
    el.style.setProperty('position', 'relative', 'important');

    if (isMobile) {
      el.style.setProperty('top', '-6px', 'important');
    } else if (isTablet) {
      el.style.setProperty('top', '0px', 'important');
    } else if (isDesktop) {
      el.style.setProperty('top', '-12px', 'important');
    }
  });

  document.querySelectorAll('.m-product-card__title, .m-product-card__price').forEach((el) => {
    el.style.setProperty('position', 'relative', 'important');

    if (isMobile) {
      el.style.setProperty('top', '-4px', 'important');
    } else if (isTablet) {
      el.style.setProperty('top', '0px', 'important');
    } else if (isDesktop) {
      el.style.setProperty('top', '-4px', 'important');
    }
  });
}

document.addEventListener('DOMContentLoaded', movePillsAndContent);
window.addEventListener('load', movePillsAndContent);
window.addEventListener('resize', movePillsAndContent);

setTimeout(movePillsAndContent, 700);
setTimeout(movePillsAndContent, 1600);

document.addEventListener('DOMContentLoaded', function () {
  function movePercentBadges() {
    const cards = document.querySelectorAll('.m-product-card');

    cards.forEach((card) => {
      const tagsWrap = card.querySelector('.m-product-card__tags');
      if (!tagsWrap) return;

      const tags = Array.from(tagsWrap.querySelectorAll('.m-product-tag, .m-product-card__tag-name'));
      if (!tags.length) return;

      let percentBadge = null;

      tags.forEach((tag) => {
        const txt = (tag.textContent || '').trim();

        // on cible UNIQUEMENT les vrais badges de remise %
        if (/^-?\d+\s?%$/.test(txt)) {
          percentBadge = tag;
        }
      });

      // reset de base
      tagsWrap.style.display = '';
      tagsWrap.style.position = '';
      tagsWrap.style.left = '';
      tagsWrap.style.right = '';
      tagsWrap.style.top = '';

      tags.forEach((tag) => {
        tag.style.marginLeft = '';
        tag.style.position = '';
        tag.style.right = '';
        tag.style.left = '';
        tag.style.top = '';
      });

      // si aucun badge % trouvé, on ne touche à rien
      if (!percentBadge) return;

      // on prépare le conteneur
      tagsWrap.style.position = 'absolute';
      tagsWrap.style.top = '10px';
      tagsWrap.style.left = '10px';
      tagsWrap.style.right = '10px';

      // seul le badge % part à droite
      percentBadge.style.marginLeft = 'auto';

      // si le parent n'est pas en flex, on le force
      const computedDisplay = window.getComputedStyle(tagsWrap).display;
      if (computedDisplay !== 'flex') {
        tagsWrap.style.display = 'flex';
        tagsWrap.style.alignItems = 'flex-start';
        tagsWrap.style.gap = '6px';
        tagsWrap.style.flexWrap = 'nowrap';
      }
    });
  }

  // lancement initial
  movePercentBadges();

  // relance après chargement dynamique du thème
  setTimeout(movePercentBadges, 300);
  setTimeout(movePercentBadges, 800);
  setTimeout(movePercentBadges, 1500);

  // relance si le DOM change (utile mobile / slider / lazy load)
  const observer = new MutationObserver(() => {
    movePercentBadges();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // relance au resize
  window.addEventListener('resize', movePercentBadges);
});

document.addEventListener('DOMContentLoaded', function () {
  function styleUSBadges() {
    const badges = document.querySelectorAll('.m-product-tag, .m-product-card__tag-name');

    badges.forEach((badge) => {
      const txt = (badge.innerText || badge.textContent || '').trim().toUpperCase();

      // cible uniquement les badges contenant "CALI"
      if (txt.includes('CALI') || txt.includes('VENDU') || txt.includes('LIMIT')) {
        badge.style.background = '#000000';
        badge.style.color = '#ffffff';
        badge.style.border = 'none';
        badge.style.boxShadow = 'none';
      }
    });
  }

  styleUSBadges();
  setTimeout(styleUSBadges, 400);
  setTimeout(styleUSBadges, 1000);

  new MutationObserver(() => {
    styleUSBadges();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener('DOMContentLoaded', function () {
  function fixBadgeRadius() {
    const badges = document.querySelectorAll(`
      .m-product-tag,
      .m-product-card__tag,
      .m-product-tag span,
      .m-product-card__tag span,
      .product-tag,
      .product-tag span,
      .tag,
      .tag span
    `);

    badges.forEach((badge) => {
      const txt = (badge.innerText || badge.textContent || '').trim().toUpperCase();

      if (
        txt.includes('CALI') ||
        txt.includes('EXLU') ||
        txt.includes('LIMIT') ||
        txt.includes('%')
      ) {
        badge.style.setProperty('border-radius', '8px', 'important');
      }
    });
  }

  fixBadgeRadius();
  window.addEventListener('load', fixBadgeRadius);
  setTimeout(fixBadgeRadius, 300);
  setTimeout(fixBadgeRadius, 800);
  setTimeout(fixBadgeRadius, 1500);

  new MutationObserver(() => {
    fixBadgeRadius();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener('DOMContentLoaded', function () {
  function normalizeAllProductBadges() {
    const selectors = [
      '.m-product-tag',
      '.m-product-tag span',
      '.m-product-tag a',
      '.m-product-tag div',
      '.m-product-card__tag',
      '.m-product-card__tag span',
      '.m-product-card__tag a',
      '.m-product-card__tag div',
      '.product-tag',
      '.product-tag span',
      '.product-tag a',
      '.product-tag div',
      '.tag',
      '.tag span',
      '.tag a',
      '.tag div',
      '[class*="badge"]',
      '[class*="badge"] span',
      '[class*="badge"] a',
      '[class*="badge"] div',
      '[class*="tag"]',
      '[class*="tag"] span',
      '[class*="tag"] a',
      '[class*="tag"] div'
    ];

    const badges = document.querySelectorAll(selectors.join(','));

    badges.forEach((badge) => {

      const txt = (badge.innerText || badge.textContent || '').trim().toUpperCase();

      if (
        txt.includes('NEW') ||
        txt.includes('EXLU') ||
        txt.includes('TOP') ||
        txt.includes('BEST') ||
        txt.includes('PETIT PRIX') ||
        txt.includes('OFFERT') ||
        txt.includes('CALI') ||
        txt.includes('VENDU') ||
        txt.includes('LIMIT') ||
        txt.includes('PUISSANT') ||
        txt.includes('%')
      ) {
        badge.style.setProperty('border-radius', '6px', 'important');
        badge.style.setProperty('padding', '2px 8px', 'important');
        badge.style.setProperty('font-size', '8px', 'important');
        badge.style.setProperty('font-weight', '600', 'important');
        badge.style.setProperty('min-height', 'auto', 'important');
        badge.style.setProperty('height', 'auto', 'important');
        badge.style.setProperty('line-height', '1.1', 'important');
        badge.style.setProperty('overflow', 'hidden', 'important');
        badge.style.setProperty('display', 'inline-flex', 'important');
        badge.style.setProperty('align-items', 'center', 'important');
        badge.style.setProperty('justify-content', 'center', 'important');
        badge.style.setProperty('white-space', 'nowrap', 'important')
      }
    });
  }

  normalizeAllProductBadges();

  window.addEventListener('load', normalizeAllProductBadges);

  setTimeout(normalizeAllProductBadges, 200);
  setTimeout(normalizeAllProductBadges, 600);
  setTimeout(normalizeAllProductBadges, 1200);
  setTimeout(normalizeAllProductBadges, 2000);
  setTimeout(normalizeAllProductBadges, 3000);

  new MutationObserver(() => {
    normalizeAllProductBadges();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
});

(function () {
  function fixJudgeBadge() {
    const isMobile = window.innerWidth < 768;

    document.querySelectorAll('.jdgm-widget.jdgm-preview-badge').forEach(function (widget) {
      widget.style.setProperty('display', 'flex', 'important');
      widget.style.setProperty('justify-content', 'flex-start', 'important');
      widget.style.setProperty('align-items', 'center', 'important');
      widget.style.setProperty('width', '100%', 'important');
      widget.style.setProperty('max-width', '100%', 'important');
      widget.style.setProperty('text-align', 'left', 'important');

      if (isMobile) {
        widget.style.setProperty('margin-top', '6px', 'important');
        widget.style.setProperty('padding-left', '0px', 'important');
      } else {
        widget.style.setProperty('margin-top', '8px', 'important');
        widget.style.setProperty('padding-left', '10px', 'important');
      }
    });

    document.querySelectorAll('.jdgm-prev-badge').forEach(function (badge) {
      badge.style.setProperty('display', 'inline-flex', 'important');
      badge.style.setProperty('align-items', 'center', 'important');
      badge.style.setProperty('justify-content', 'flex-start', 'important');
      badge.style.setProperty('gap', '10px', 'important');
      badge.style.setProperty('margin', '0', 'important');
      badge.style.setProperty('padding', '0', 'important');
      badge.style.setProperty('width', 'auto', 'important');
      badge.style.setProperty('max-width', '100%', 'important');
      badge.style.setProperty('text-align', 'left', 'important');
      badge.style.setProperty('white-space', 'nowrap', 'important');
    });

    document.querySelectorAll('.jdgm-prev-badge__stars').forEach(function (stars) {
      stars.style.setProperty('display', 'inline-flex', 'important');
      stars.style.setProperty('align-items', 'center', 'important');
      stars.style.setProperty('gap', isMobile ? '7px' : '8px', 'important');
      stars.style.setProperty('margin', '0', 'important');
      stars.style.setProperty('padding', '0', 'important');
      stars.style.setProperty('line-height', '1', 'important');
      stars.style.setProperty('white-space', 'nowrap', 'important');
    });

    document.querySelectorAll('.jdgm-prev-badge__stars .jdgm-star').forEach(function (star) {
      star.style.setProperty('margin', '0', 'important');
      star.style.setProperty('padding', '0', 'important');
      star.style.setProperty('line-height', '1', 'important');
      star.style.setProperty('display', 'inline-block', 'important');
    });

    document.querySelectorAll('.jdgm-prev-badge__text').forEach(function (text) {
      text.style.setProperty('margin', '0', 'important');
      text.style.setProperty('padding', '0', 'important');
      text.style.setProperty('line-height', '1', 'important');
      text.style.setProperty('white-space', 'nowrap', 'important');
    });
  }

  function runFix() {
    fixJudgeBadge();
    setTimeout(fixJudgeBadge, 300);
    setTimeout(fixJudgeBadge, 800);
    setTimeout(fixJudgeBadge, 1500);
  }

  document.addEventListener('DOMContentLoaded', runFix);
  window.addEventListener('load', runFix);
  window.addEventListener('resize', runFix);

  new MutationObserver(runFix).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  function fixProductBadges() {
    const groups = document.querySelectorAll(".product-block-group--tags");

    groups.forEach(function (group) {
      const parent = group.parentElement;

      if (parent) {
        parent.style.transform = "none";
        parent.style.transition = "none";
        parent.style.animation = "none";
        parent.style.willChange = "auto";
      }

      group.style.display = "flex";
      group.style.flexWrap = "wrap";
      group.style.gap = "6px";
      group.style.width = "auto";
      group.style.maxWidth = "max-content";
      group.style.margin = "12px 0 1px -16px";
      group.style.padding = "0";
      group.style.transform = "none";
      group.style.transition = "none";
      group.style.animation = "none";
      group.style.willChange = "auto";

      group.querySelectorAll(".m-product-tag").forEach(function (tag) {
        tag.style.display = "inline-flex";
        tag.style.alignItems = "center";
        tag.style.justifyContent = "center";
        tag.style.width = "auto";
        tag.style.maxWidth = "max-content";
        tag.style.flex = "0 0 auto";
        tag.style.padding = "4px 10px";
        tag.style.borderRadius = "999px";
        tag.style.lineHeight = "1.1";
        tag.style.whiteSpace = "nowrap";
        tag.style.transform = "none";
        tag.style.transition = "none";
        tag.style.animation = "none";
        tag.style.willChange = "auto";
      });
    });
  }

  fixProductBadges();
  requestAnimationFrame(fixProductBadges);
});

document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.innerWidth < 768;

  document.querySelectorAll('.jdgm-prev-badge, .jdgm-widget.jdgm-preview-badge').forEach(function (badge) {
    const starsWrap = badge.querySelector('.jdgm-prev-badge__stars');
    const text = badge.querySelector('.jdgm-prev-badge__text');

    if (!starsWrap || !text) return;

    // ligne avis = on garde ta logique stable
    badge.style.display = "inline-flex";
    badge.style.alignItems = "center";
    badge.style.justifyContent = isMobile ? "flex-start" : "center";
    badge.style.flexWrap = "nowrap";
    badge.style.gap = isMobile ? "6px" : "8px";
    badge.style.margin = "0";
    badge.style.padding = "0";
    badge.style.lineHeight = "1";
    badge.style.width = "auto";
    badge.style.maxWidth = "100%";
    badge.style.overflow = "visible";
    badge.style.verticalAlign = "middle";

    // étoiles
    starsWrap.style.display = "inline-flex";
    starsWrap.style.alignItems = "center";
    starsWrap.style.justifyContent = "flex-start";
    starsWrap.style.flex = "0 0 auto";
    starsWrap.style.width = "auto";
    starsWrap.style.minWidth = "auto";
    starsWrap.style.maxWidth = "none";
    starsWrap.style.margin = "0";
    starsWrap.style.padding = "0";
    starsWrap.style.lineHeight = "1";
    starsWrap.style.whiteSpace = "nowrap";
    starsWrap.style.overflow = "visible";
    starsWrap.style.verticalAlign = "middle";
    starsWrap.style.color = "#000000ff";
    starsWrap.style.webkitTextFillColor = "#000000ff";

    // même taille pour étoiles vides / pleines / demi
    badge.querySelectorAll('.jdgm-star, .jdgm-star span').forEach(function (star) {
      star.style.display = "inline-flex";
      star.style.alignItems = "center";
      star.style.justifyContent = "center";
      star.style.boxSizing = "border-box";
      star.style.fontSize = isMobile ? "12px" : "13px";
      star.style.width = isMobile ? "12px" : "13px";
      star.style.minWidth = isMobile ? "12px" : "13px";
      star.style.height = isMobile ? "12px" : "13px";
      star.style.margin = "0 2px 0 0";
      star.style.padding = "0";
      star.style.lineHeight = "1";
      star.style.verticalAlign = "middle";
      star.style.color = "#000000ff";
      star.style.webkitTextFillColor = "#000000ff";
      star.style.transform = "none";
    });

    badge.querySelectorAll('.jdgm-star.jdgm--off, .jdgm-star.jdgm--on, .jdgm-star.jdgm--half').forEach(function (star) {
      star.style.color = "#000000ff";
      star.style.webkitTextFillColor = "#000000ff";
      star.style.fontSize = isMobile ? "12px" : "13px";
      star.style.width = isMobile ? "12px" : "13px";
      star.style.minWidth = isMobile ? "12px" : "13px";
      star.style.height = isMobile ? "12px" : "13px";
      star.style.lineHeight = "1";
      star.style.transform = "none";
    });

    // texte avis
    text.style.display = "inline-block";
    text.style.flex = "0 0 auto";
    text.style.fontSize = isMobile ? "11px" : "12px";
    text.style.fontWeight = "500";
    text.style.whiteSpace = "nowrap";
    text.style.margin = "0";
    text.style.padding = "0";
    text.style.lineHeight = "1";
    text.style.visibility = "visible";
    text.style.opacity = "1";
    text.style.verticalAlign = "middle";

    // couleur texte = couleur du titre
    const card =
      badge.closest('.m-product-card') ||
      badge.closest('.sf__pcard') ||
      badge.closest('.m-product-item') ||
      badge.parentElement;

    const title =
      card?.querySelector('.m-product-card__title') ||
      card?.querySelector('.m-product-card__title a') ||
      card?.querySelector('.m-product-card__name') ||
      card?.querySelector('.m-product-card__name a') ||
      card?.querySelector('h3');

    text.style.color = title
      ? window.getComputedStyle(title).color
      : "#111111";
  });

  document.querySelectorAll('.m-product-card__reviews').forEach(function (wrap) {
    wrap.style.display = "block";
    wrap.style.width = "100%";
    wrap.style.margin = isMobile ? "-8px 0 14px 0" : "-4px auto 12px auto";
    wrap.style.padding = "0";
    wrap.style.lineHeight = "1";
    wrap.style.overflow = "visible";
    wrap.style.textAlign = isMobile ? "left" : "center";
  });
});

function hideNoReviewsText() {
  document.querySelectorAll('.jdgm-prev-badge__text').forEach(function (el) {
    const txt = (el.textContent || "").trim().toLowerCase();

    if (
      txt.includes("aucun avis") ||
      txt.includes("no reviews") ||
      txt === "0 avis"
    ) {
      el.style.display = "none";
      el.style.visibility = "hidden";
      el.style.opacity = "0";
      el.style.width = "0";
      el.style.minWidth = "0";
      el.style.maxWidth = "0";
      el.style.margin = "0";
      el.style.padding = "0";
      el.style.overflow = "hidden";
      el.textContent = "";
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  hideNoReviewsText();

  setTimeout(hideNoReviewsText, 400);
  setTimeout(hideNoReviewsText, 1000);
  setTimeout(hideNoReviewsText, 1800);

  const observer = new MutationObserver(function () {
    hideNoReviewsText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.innerWidth < 768;
  const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;

  document.querySelectorAll('.jdgm-prev-badge, .jdgm-widget.jdgm-preview-badge').forEach(function (badge) {
    const starsWrap = badge.querySelector('.jdgm-prev-badge__stars');
    const text = badge.querySelector('.jdgm-prev-badge__text');

    if (!starsWrap || !text) return;

    // badge principal
    badge.style.display = "inline-flex";
    badge.style.alignItems = "center";
    badge.style.justifyContent = "flex-start";
    badge.style.flexWrap = "nowrap";
    badge.style.gap = isMobile ? "6px" : "7px";
    badge.style.margin = "0";
    badge.style.padding = "0";
    badge.style.lineHeight = "1";
    badge.style.width = "auto";
    badge.style.maxWidth = "100%";
    badge.style.overflow = "visible";
    badge.style.verticalAlign = "middle";
    badge.style.position = "relative";

    // uniquement PC + tablette : petit décalage horizontal
    // sans toucher au vertical
    if (isTablet) {
      badge.style.left = "-2px";
    } else if (!isMobile) {
      badge.style.left = "-4px";
    } else {
      badge.style.left = "0";
    }

    // étoiles
    starsWrap.style.display = "inline-flex";
    starsWrap.style.alignItems = "center";
    starsWrap.style.justifyContent = "flex-start";
    starsWrap.style.flex = "0 0 auto";
    starsWrap.style.width = "auto";
    starsWrap.style.minWidth = "auto";
    starsWrap.style.maxWidth = "none";
    starsWrap.style.margin = "0";
    starsWrap.style.padding = "0";
    starsWrap.style.lineHeight = "1";
    starsWrap.style.whiteSpace = "nowrap";
    starsWrap.style.overflow = "visible";
    starsWrap.style.position = "relative";
    starsWrap.style.top = "0";
    starsWrap.style.left = "0";

    // texte
    text.style.display = "inline-flex";
    text.style.alignItems = "center";
    text.style.margin = "0";
    text.style.padding = "0";
    text.style.lineHeight = "1";
    text.style.whiteSpace = "nowrap";
    text.style.position = "relative";
    text.style.top = "0";
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function hideReviewsInTargetSections() {
    document.querySelectorAll("h1, h2, h3, h4").forEach(function (heading) {
      const title = (heading.textContent || "").trim().toLowerCase();

      const isTarget =
        title.includes("vous aimerez sûrement") ||
        title.includes("produits récemment consultés");

      if (!isTarget) return;

      const section =
        heading.closest(".shopify-section") ||
        heading.closest("section") ||
        heading.parentElement;

      if (!section) return;

      section.querySelectorAll(".m-product-card__reviews").forEach(function (wrap) {
        wrap.style.setProperty("display", "none", "important");
        wrap.style.setProperty("height", "0", "important");
        wrap.style.setProperty("margin", "0", "important");
        wrap.style.setProperty("padding", "0", "important");
        wrap.style.setProperty("overflow", "hidden", "important");
      });
    });
  }

  hideReviewsInTargetSections();
  setTimeout(hideReviewsInTargetSections, 700);
  setTimeout(hideReviewsInTargetSections, 1500);
  setTimeout(hideReviewsInTargetSections, 2500);
});

/* ANONYM — remplace "achat rapide" par lien produit */
(function () {
  function fixQuickAdd() {
    document.querySelectorAll('.m-add-to-cart, .m-quick-add, .btn-add-to-cart').forEach(btn => {
      
      // évite de modifier plusieurs fois
      if (btn.dataset.fixed) return;

      const card = btn.closest('.m-product-card');
      if (!card) return;

      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      btn.dataset.fixed = "true";

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = link.href;
      });
    });
  }

  // lance plusieurs fois (lazy load / mobile)
  fixQuickAdd();
  setTimeout(fixQuickAdd, 500);
  setTimeout(fixQuickAdd, 1500);
  setTimeout(fixQuickAdd, 3000);
})();

/* ANONYM — STOP CLIGNOTEMENT PASTILLES + STYLE CLAIR */
(function () {
  const lastInterval = setInterval(function(){}, 9999);
  for (let i = 1; i <= lastInterval; i++) {
    clearInterval(i);
  }

  function fixPillsFinal() {
    document.querySelectorAll('.anonym-pill').forEach(function (pill) {
      pill.style.setProperty('background', '#1a1a1a', 'important');
      pill.style.setProperty('color', '#ffffff', 'important');
      pill.style.setProperty('border', '1px solid #333333', 'important');
      pill.style.setProperty('opacity', '1', 'important');
      pill.style.setProperty('filter', 'none', 'important');
      pill.style.setProperty('box-shadow', 'none', 'important');
      pill.style.setProperty('transition', 'none', 'important');
      pill.style.setProperty('animation', 'none', 'important');
      pill.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
    });
  }

  fixPillsFinal();
  setTimeout(fixPillsFinal, 100);
  setTimeout(fixPillsFinal, 500);
  setTimeout(fixPillsFinal, 1200);

  new MutationObserver(fixPillsFinal).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* ANONYM — PASTILLES FULL WIDTH DANS SLIDERS PRODUITS */
(function () {
  function fixSliderPillsWidth() {
    document.querySelectorAll('.m-product-card .anonym-card-meta').forEach(function (meta) {
      meta.style.setProperty('display', 'flex', 'important');
      meta.style.setProperty('width', '100%', 'important');
      meta.style.setProperty('gap', '8px', 'important');
      meta.style.setProperty('flex-wrap', 'nowrap', 'important');

      meta.querySelectorAll('.anonym-pill').forEach(function (pill) {
        pill.style.setProperty('flex', '1 1 0', 'important');
        pill.style.setProperty('width', '50%', 'important');
        pill.style.setProperty('min-width', '0', 'important');
        pill.style.setProperty('justify-content', 'center', 'important');
        pill.style.setProperty('text-align', 'center', 'important');
        pill.style.setProperty('white-space', 'nowrap', 'important');
      });
    });
  }

  fixSliderPillsWidth();
  setTimeout(fixSliderPillsWidth, 300);
  setTimeout(fixSliderPillsWidth, 1000);
  setTimeout(fixSliderPillsWidth, 2000);

  new MutationObserver(fixSliderPillsWidth).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

